<!--
//================================================================================
// ID:BC058C1
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC058C1
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/11/15 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.02.00 | 2023/04/26 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.03.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.04.00 | 2024/09/20 | 富士通Japan株式会社    | 令和6年度改修対応（1次リリース）
//================================================================================
-->
<template>
	<main class="contents__main">
		<error-message />
		<!--◆編集エリア START◆-->
		<div class="contents__input-main">
			<div class="contents__title">
				<label class="contents__title--label"></label>
			</div>
			<br/>
			<div class="contents__information">
				<div class="padding__bottom-20 padding__top-5">
					<font-awesome-icon icon="exclamation-triangle" />
					<label class="width-attention">注意事項</label>
				</div>
				<div class="contents__attention">
					<ul>
						<li>{{ co_getMessage('I0009') }}</li>
					</ul>
					<br/>
				</div>
			</div>
			<br/>
			<h2 class="contents__h2 contents__jyutaku">申込む住宅</h2>
			<input type="button" value="住宅変更（検索画面へ）"	class="contents__btn--cancel width-jyutakuhenko" v-on:click="clickJyutakuHenko()" tabindex="1" />
			<div>
				<section class="margin__bottom-m10">
					<table border="1" class="list border__collapse">
						<thead>
							<tr id="listheader">
								<th id="listtitle01">
									<a :href="disp.nyukyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">入居人数</a>
								</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle02">申込地区番号<br>
								</th>
								<th v-else id="listtitle12">申込地区番号<br>
								</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle03">
									<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
									<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
									<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a>
								</th>
								<th v-else-if="disp.listHideKbn == 2" id="listtitle13">
									<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
									<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
									<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a></th>
								<th v-else id="listtitle23">
									<a :href="disp.jyutakuLink" target="_blank" rel="noopener noreferrer" tabindex="-1">住宅名</a><br>
									<a :href="disp.syozaitiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">代表的な所在地</a><br>
									<a :href="disp.transLink" target="_blank" rel="noopener noreferrer" tabindex="-1">主な交通機関</a></th>
								<th id="listtitle05">間取り<br>専用面積<br />(m&sup2;)</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle06">
									<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a><br>
									<a :href="disp.elevatorLink" target="_blank" rel="noopener noreferrer" tabindex="-1">エレベーター</a><br>
									<a :href="disp.taisyokaiLink" target="_blank" rel="noopener noreferrer" tabindex="-1">対象階</a>
								</th>
								<th v-else id="listtitle06">
									<a :href="disp.buildLink" target="_blank" rel="noopener noreferrer" tabindex="-1">建設年度</a><br>
									<a :href="disp.elevatorLink" target="_blank" rel="noopener noreferrer" tabindex="-1">エレベーター</a></th>
								<th id="listtitle07">
									<a :href="disp.shiyoryoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">使用料(円)</a>
								</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle08">
									<a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a>
								</th>
								<th v-else id="listtitle18">
									<a :href="disp.shiyoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">仕様等</a>
								</th>
								<th v-if="disp.listHideKbn == 1" id="listtitle09">
									<a :href="disp.jikoLink" target="_blank" rel="noopener noreferrer" tabindex="-1">事故内容</a>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr class="list-Countents">
								<td id="listtd">{{ disp.nyukyoSu }}</td>
								<td id="listtd">{{ disp.noMouchiku }}</td>
								<td id="listjyusho">
									<label id="listtdleft">{{ disp.jyutakuName }}</label><br />
									<label id="listtdleft">{{ disp.kusicyo }}</label><br />
									<label id="listtdleft">{{ disp.trans }}</label>
								</td>
								<td id="listtd" class="contents__kaigyo--css">{{ disp.madori }}<br />{{ disp.senyoArea }}</td>
								<td id="listtd" v-if="disp.listHideKbn == 1">
									{{ disp.ymkensetu }}<br />{{ disp.elevatorUmu }}<br />{{ disp.jikotaisyo }}
								</td>
								<td id="listtd" v-else>
									{{ disp.ymkensetu }}<br />{{ disp.elevatorUmu }}
								</td>
								<td id="listtd">{{ disp.moSiyoryo }}</td>
								<td id="listtdleft">{{ disp.siyouEtc }}</td>
								<td id="listtdleft" v-if="disp.listHideKbn == 1">
									{{ disp.jikonaiyo }}
								</td>
							</tr>
						</tbody>
					</table>
				</section>
			</div>
			<section>
				<h2 class="contents__h2 contents__mosikomi1">申込情報</h2>
				<table class="contents__table--stripe detail_split" >
					<tbody>
						<tr class="contents__input--tr">
							<th class="contents__input--title">募集の種類</th>
							<td class="width-bosyu">
								{{ disp.nmBosyu }}
							</td>
							<th class="contents__input--title">住宅の種別</th>
							<td class="width-jyutaku padding-jyutaku">
								<div>
									<p style="line-height: 1em;display: table-cell;">
										{{ disp.nmZyutaku }}
									</p>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title">現在、申込者を含め同居している人数<span class="contents__hissu">必須</span></th>
							<td colspan="3">
								<number-input
									class="contents__input--text width-dokyo"
									:modelValue="formC1.nuDoukyo"
									:maxLength="2"
									:name="'同居人数'"
									:groupId="'nuDoukyo'"
									:requireFlg="true"
									:numberType="NUMBERINPUT_TYPE.INTEGER"
									@update:modelValue="formC1.nuDoukyo = $event"
									ref="nuDoukyo"
									tabindex="2"
								/>人
								<itemerror-message :groupId="'nuDoukyo'"/>
								<caution-message
									:classDiv="'contents__caution--div'"
									:tyuibunItems="disp.dokyoItems"
								/>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title">都営住宅に入居する人数<span class="contents__hissu">必須</span></th>
							<td colspan="3">
								<nyukyo-num
									:modelValue="formC1.nuNyukyo"
									:name="'都営住宅に入居する人数'"
									:groupId="'nuNyukyo'"
									:requireFlg="true"
									:startNum="formC1.zyutakuInfo.nmNyukyoLow"
									:endNum="formC1.zyutakuInfo.nmNyukyoUpr"
									@update:modelValue="changenuNyukyo"
									ref="nuNyukyo"
									tabindex="3"
								/>
								<itemerror-message :groupId="'nuNyukyo'"/>
								<div class="contents__caution--div contents__nyukyotyui1">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											申込者本人を含めた人数を入力してください。
										</p>
									</div>
								</div>
								<caution-message
									:classDiv="'contents__caution--div contents__nyukyotyui2'"
									:tyuibunItems="disp.nyukyoItems1"
								/>
							</td>
						</tr>
						<tr class="contents__input--tr">
							<th class="contents__input--title">申込区分<span class="contents__hissu">必須</span></th>
							<td  colspan="3">
								<list-box
									class="contents__input--select width-mosikomi"
									:modelValue="formC1.kbMosikomi"
									:name="'申込区分'"
									:groupId="'kbMosikomi'"
									:listItems="disp.mouKbnList"
									:cdKbn="CD_HANDLE_TYPE.CD_HANYO1"
									:requireFlg="true"
									:reducedDisplayFlg="true"
									@update:modelValue="changeMosikomiList"
									ref="kbMosikomi"
									tabindex="4" />
								<itemerror-message :groupId="'kbMosikomi'"/>
								<caution-message
									:classDiv="'width-moukbn1'"
									:cdHanyo1="'T0010'"
									:cdHanyo2="formC1.mouItems1cdHanyo2"
								/>
							</td>
						</tr>
					</tbody>
				</table>
				<br/>
				<h2 class="contents__h2 contents__mosikomi2">申込者情報（この方が都営住宅使用許可後の名義人となります。）</h2>
				<table class="contents__table--stripe detail" >
					<tbody>
						<tr>
							<th  class="contents__input--title border__bottom-none">
								申込者<span class="contents__hissu">必須</span>
							</th>
							<td class="border__bottom-none mouName-title">
								<div id="contents--name__area">
									<div>
										氏：<text-input
												class="contents__input--text"
												:modelValue="formC1.nmMouname1"
												:maxLength="15"
												:textType="TEXTINPUT_TYPE.FULL"
												:name="'申込者（氏）'"
												:groupId="'nmMouname'"
												:placeholder="'例）東京'"
												:requireFlg="true"
												@update:modelValue="formC1.nmMouname1 = $event"
												ref="nmMouname1"
												tabindex="5" />
									</div>
									<div>
										名：<text-input
												class="contents__input--text"
												:modelValue="formC1.nmMouname2"
												:maxLength="15"
												:textType="TEXTINPUT_TYPE.FULL"
												:name="'申込者（名）'"
												:groupId="'nmMouname'"
												:placeholder="'例）太郎'"
												:requireFlg="true"
												@update:modelValue="formC1.nmMouname2 = $event"
												ref="nmMouname2"
												tabindex="6" />
									</div>
								</div>
								<itemerror-message :groupId="'nmMouname'"/>
							</td>
						</tr>
						<tr class="background__color--white">
							<th  class="contents__input--title">
								フリガナ<span class="contents__hissu">必須</span>
							</th>
							<td>
								<div id="contents--name__area">
									<div>
										氏：<text-input
												class="contents__input--text"
												:modelValue="formC1.nmMoukana1"
												:maxLength="30"
												:textType="TEXTINPUT_TYPE.HALF_KANA"
												:name="'フリガナ（氏）'"
												:groupId="'nmMoukana'"
												:placeholder="'例）ﾄｳｷｮｳ'"
												:requireFlg="true"
												@update:modelValue="formC1.nmMoukana1 = $event"
												ref="nmMoukana1"
												tabindex="7" />
									</div>
									<div>
										名：<text-input
												class="contents__input--text"
												:modelValue="formC1.nmMoukana2"
												:maxLength="30"
												:textType="TEXTINPUT_TYPE.HALF_KANA"
												:name="'フリガナ（名）'"
												:groupId="'nmMoukana'"
												:placeholder="'例）ﾀﾛｳ'"
												:requireFlg="true"
												@update:modelValue="formC1.nmMoukana2 = $event"
												ref="nmMoukana2"
												tabindex="8" />
									</div>
								</div>
								<itemerror-message :groupId="'nmMoukana'"/>
								<div class="contents__caution--div div_row font-size">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											カタカナで入力してください。
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr class="background__color--light-gray">
							<th  class="contents__input--title border__bottom-none">
								日本での通称名
							</th>
							<td class="border__bottom-none">
								<div class="contents__tusyoTyui">
									<font-awesome-icon icon="exclamation-triangle" />
									<label class="margin__tusyoTyui">申込者が外国人で、日本式の名前を住民票に登録している場合のみ、入力してください。</label>
								</div>
								<div id="contents--name__area">
									<div>
										氏：<text-input
												class="contents__input--text"
												:modelValue="formC1.nmMoutusyoname1"
												:maxLength="15"
												:textType="TEXTINPUT_TYPE.FULL"
												:name="'通称名（氏）'"
												:groupId="'nmMoutusyoname'"
												:placeholder="'例）東'"
												@update:modelValue="formC1.nmMoutusyoname1 = $event"
												ref="nmMoutusyoname1"
												tabindex="9" />
									</div>
									<div>
										名：<text-input
												class="contents__input--text"
												:modelValue="formC1.nmMoutusyoname2"
												:maxLength="15"
												:textType="TEXTINPUT_TYPE.FULL"
												:name="'通称名（名）'"
												:groupId="'nmMoutusyoname'"
												:placeholder="'例）太郎'"
												@update:modelValue="formC1.nmMoutusyoname2 = $event"
												ref="nmMoutusyoname2"
												tabindex="10" />
									</div>
								</div>
								<itemerror-message :groupId="'nmMoutusyoname'"/>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title">
								通称名のフリガナ
							</th>
							<td>
								<div id="contents--name__area">
									<div>
										氏：<text-input
												class="contents__input--text"
												:modelValue="formC1.nmMoutusyokana1"
												:maxLength="30"
												:textType="TEXTINPUT_TYPE.HALF_KANA"
												:name="'通称名フリガナ（氏）'"
												:groupId="'nmMoutusyokana'"
												:placeholder="'例）ﾄｳ'"
												@update:modelValue="formC1.nmMoutusyokana1 = $event"
												ref="nmMoutusyokana1"
												tabindex="11" />
									</div>
									<div>
										名：<text-input
												class="contents__input--text"
												:modelValue="formC1.nmMoutusyokana2"
												:maxLength="30"
												:textType="TEXTINPUT_TYPE.HALF_KANA"
												:name="'通称名フリガナ（名）'"
												:groupId="'nmMoutusyokana'"
												:placeholder="'例）ﾀﾛｳ'"
												@update:modelValue="formC1.nmMoutusyokana2 = $event"
												ref="nmMoutusyokana2"
												tabindex="12" />
									</div>
								</div>
								<itemerror-message :groupId="'nmMoutusyokana'"/>
								<div class="contents__caution--div div_row font-size">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											カタカナで入力してください。
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title">生年月日<span class="contents__hissu">必須</span></th>
							<td>
								<date-input
									:modelValue="formC1.dtMoubirthday"
									:name="'生年月日'"
									:groupId="'birthDay'"
									:requireFlg="true"
									:dateType="DATE_KIND.BIRTHDAY"
									:ageViewFlg="true"
									@update:modelValue="formC1.dtMoubirthday = $event"
									ref="dtMoubirthday"
									tabindex="13"
								/>
								<itemerror-message :groupId="'birthDay'"/>
								<caution-message
									:tyuibunItems="disp.ageItems1"
								/>
								<caution-message
									:tyuibunItems="disp.ageItems2"
								/>
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title">郵便番号<span class="contents__hissu">必須</span></th>
							<td>
								<number-input
									class="contents__input--text width-zip1 text-align-left"
									:modelValue="formC1.noMouzip1"
									:maxLength="3"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:name="'郵便番号（上３桁）'"
									:groupId="'noMouzip'"
									:placeholder="'例）001'"
									:requireFlg="true"
									@update:modelValue="formC1.noMouzip1 = $event"
									ref="noMouzip1"
									tabindex="16" />
								-
								<number-input
									class="contents__input--text width-zip2 text-align-left"
									:modelValue="formC1.noMouzip2"
									:maxLength="4"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:name="'郵便番号（下４桁）'"
									:groupId="'noMouzip'"
									:placeholder="'例）0001'"
									:requireFlg="true"
									@update:modelValue="formC1.noMouzip2 = $event"
									ref="noMouzip2"
									tabindex="17" />
								&nbsp;
								<input type="button" value="住所検索" class="contents__btn--normal_jyusyo" tabindex="18" @click="searchZyusyo"/>
								<br/>
								<itemerror-message :groupId="'noMouzip'"/>
								<div class="contents__caution--div div_row font-size">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											数字で入力してください。
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title">現住所<span class="contents__hissu">必須</span><br/>
							</th>
							<td>
								<text-input
									class="contents__input--text width-jyusyo"
									:modelValue="formC1.txMouadr1"
									:maxLength="20"
									:textType="TEXTINPUT_TYPE.FULL"
									:name="'現住所１'"
									:groupId="'txMouadr'"
									:placeholder="'例）東京都新宿区西新宿５丁目○○－○○'"
									:requireFlg="true"
									@update:modelValue="formC1.txMouadr1 = $event"
									ref="txMouadr1"
									tabindex="19" />
								<div class="div_row">
									<text-input
										class="contents__input--text width-jyusyo"
										:modelValue="formC1.txMouadr2"
										:maxLength="20"
										:textType="TEXTINPUT_TYPE.FULL"
										:name="'現住所２'"
										:groupId="'txMouadr'"
										:placeholder="'例）□□□ビル ９９９号室'"
										@update:modelValue="formC1.txMouadr2 = $event"
										ref="txMouadr2"
										tabindex="20" />
								</div>
								<div class="div_row">
									<text-input
										class="contents__input--text width-jyusyo"
										:modelValue="formC1.txMouadr3"
										:maxLength="20"
										:textType="TEXTINPUT_TYPE.FULL"
										:name="'現住所３'"
										:groupId="'txMouadr'"
										:placeholder="'例）○○様方'"
										@update:modelValue="formC1.txMouadr3 = $event"
										ref="txMouadr3"
										tabindex="21" />
								</div>
								<itemerror-message :groupId="'txMouadr'"/>
								<div class="contents__caution--div jyusyo-tyui2 div_row jusyo-marginTop">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											現住所は建物名まで必ず入力してください。
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title">電話番号<span class="contents__hissu">必須</span></th>
							<td>
								<number-input
									class="contents__input--text width-tel1 text-align-left"
									:modelValue="formC1.idMoutel1"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:maxLength="5"
									:name="'電話番号（市外）'"
									:groupId="'idMoutel'"
									:requireFlg="true"
									@update:modelValue="formC1.idMoutel1 = $event"
									ref="idMoutel1"
									tabindex="22" />
								&nbsp;-&nbsp;
								<number-input
									class="contents__input--text width-tel2 text-align-left"
									:modelValue="formC1.idMoutel2"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:maxLength="4"
									:name="'電話番号（市内）'"
									:groupId="'idMoutel'"
									:requireFlg="true"
									@update:modelValue="formC1.idMoutel2 = $event"
									ref="idMoutel2"
									tabindex="23" />
								&nbsp;-&nbsp;
								<number-input
									class="contents__input--text width-tel3 text-align-left"
									:modelValue="formC1.idMoutel3"
									:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
									:maxLength="4"
									:name="'電話番号（局番）'"
									:groupId="'idMoutel'"
									:requireFlg="true"
									@update:modelValue="formC1.idMoutel3 = $event"
									ref="idMoutel3"
									tabindex="24" />
								<itemerror-message :groupId="'idMoutel'"/>
								<div class="contents__caution--div div_row tel-tyui">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											平日の日中に連絡のつく電話番号を入力してください。
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title">都内居住年数<span class="contents__hissu">必須</span></th>
							<td>
								<number-input
									class="contents__input--text width-kyojyuNensu"
									:modelValue="formC1.nuKyojyu"
									:maxLength="2"
									:name="'都内居住年数'"
									:groupId="'nuKyojyu'"
									:requireFlg="true"
									:numberType="NUMBERINPUT_TYPE.INTEGER"
									@update:modelValue="formC1.nuKyojyu = $event"
									ref="nuKyojyu"
									tabindex="25"
								/> 年
								<itemerror-message :groupId="'nuKyojyu'"/>
								<div class="contents__caution--div div_row kyojyuNensu-tyui">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											現住所を含めた都内に継続して居住している年数を入力してください。
										</p>
									</div>
								</div>
								<div class="contents__caution--div div_row kyojyuNensu-tyui">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											居住年数が1年未満の場合は1年と入力してください。
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title zairyu-title">在留資格</th>
							<td class="zairyuSikaku-title">
								<div class="contents__tusyoTyui line-height">
									<font-awesome-icon icon="exclamation-triangle" />
									<label class="margin__tusyoTyui">申込者が外国人の場合のみ入力してください。</label>
								</div>
								<div class="contents__caution--div zairyu-tyui">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple" style="color:red;">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple" style="color:red;">
											外国人の申込者については、中長期在留者で、申込日から審査日まで継続して在留資格を有しており、そのことが住民票の写しで証明できることが必要です。
										</p>
									</div>
								</div>
								<list-box
									class="contents__input--select width-zairyu"
									:modelValue="formC1.kbZairyusikaku"
									:name="'在留資格'"
									:groupId="'kbZairyusikaku'"
									:cdType="'L0006'"
									:reducedDisplayFlg="true"
									@update:modelValue="changeZairyuList"
									ref="kbZairyusikaku"
									tabindex="26" />
								<itemerror-message :groupId="'kbZairyusikaku'"/>
								<caution-message
									:tyuibunItems="disp.zairyuItems"
								/>
							</td>
						</tr>
						<tr class="background__color--light-gray">
							<th class="contents__input--title">在留期間</th>
							<td>
								<date-input
									:classDiv="'width-zairyuKikanFrom'"
									:modelValue="formC1.dtZairyuStt"
									:name="'在留期間（自）'"
									:groupId="'zairyuKikan'"
									:dateType="DATE_KIND.ZAIRYU_FROM"
									:disabledFlg="(!co_isEmpty(formC1.kbZairyusikaku) && formC1.kbZairyusikaku != '3') ? false : true"
									:requireFlg="(!co_isEmpty(formC1.kbZairyusikaku) && formC1.kbZairyusikaku != '3') ? true : false"
									@update:modelValue="formC1.dtZairyuStt = $event"
									ref="dtZairyuStt"
									tabindex="27"
								/>
								<span class="br-962px"><br /></span>
								<date-input
									:classDiv="'width-zairyuKikanTo'"
									:modelValue="formC1.dtZairyuEnd"
									:name="'在留期間（至）'"
									:groupId="'zairyuKikan'"
									:dateType="DATE_KIND.ZAIRYU_TO"
									:disabledFlg="(!co_isEmpty(formC1.kbZairyusikaku) && formC1.kbZairyusikaku != '3') ? false : true"
									:requireFlg="(!co_isEmpty(formC1.kbZairyusikaku) && formC1.kbZairyusikaku != '3') ? true : false"
									@update:modelValue="formC1.dtZairyuEnd = $event"
									ref="dtZairyuEnd"
									tabindex="30"
								/>
								<itemerror-message :groupId="'zairyuKikan'"/>
							</td>
						</tr>
						<tr class="contents__input--tr background__color--white">
							<th class="contents__input--title padding__bottom-zero">
								年間所得金額<span class="contents__hissu">必須</span>
							</th>
							<td class="padding__syotoku">
								<div>
									<number-input
										class="contents__input--text width-syotoku"
										:modelValue="formC1.moSyotoku"
										:maxLength="8"
										:name="'年間所得金額'"
										:requireFlg="true"
										:numberType="NUMBERINPUT_TYPE.PERIOD"
										:groupId="'moSyotoku'"
										@update:modelValue="formC1.moSyotoku = $event"
										ref="moSyotoku"
										v-on:blur="changeMoSyotoku"
										tabindex="33"
									/>&nbsp;円
								</div>
								<itemerror-message :groupId="'moSyotoku'"/>
								<caution-message
									:tyuibunItems="disp.syotoku1Items"
								/>
								<caution-message
									:tyuibunItems="disp.syotoku2Items"
								/>
							</td>
						</tr>
						<tr class="contents__input--tr background__color--light-gray">
							<th class="contents__input--title padding__bottom-zero">特別控除</th>
							<td class="padding__kojyo">
								<div class="cond__checkbox width-kojyo-item">
									<check-box
										:classDiv="'font-size'"
										:modelValue="formC1.fgKojto"
										:cdType="'L0024'"
										:name="'特別控除'"
										:classItem="'width-kojyo-range'"
										:groupId="'fgKojto'"
										@update:modelValue="formC1.fgKojto = $event"
										ref="fgKojto"
										tabindex="34" />
								</div>
								<itemerror-message :groupId="'fgKojto'"/>
								<caution-message
									:tyuibunItems="disp.kojto1Items"
								/>
								<caution-message
									:tyuibunItems="disp.kojto2Items"
								/>
							</td>
						</tr>
					</tbody>
				</table>
				<table class="contents__table--stripe detail border__top-none accordion-title">
					<tbody>
						<tr>
							<th class="border__bottom-none"></th>
							<td class="border__bottom-none"></td>
						</tr>
						<tr>
							<th colspan="2" class="contents__filter--title height-accordion">
								<label>申込日時点の勤務先又は学校の名称・所在地（資格審査時に確認しますので、申込時点での入力は必須ではありません）</label>
								<div class="square-position2 float__right" @click="filterOpen()">
									<transition name="rotate" mode="out-in" key="rotate3">
										<font-awesome-icon :icon="['far', 'minus-square']" v-if="disp.isFilterOpen"/>
										<font-awesome-icon :icon="['far', 'plus-square']" v-else/>
									</transition>
								</div>
							</th>
						</tr>
						<tr v-if="disp.isFilterOpen" class="contents__input--tr background__color--white">
							<th class="contents__input--title padding__bottom-zero">所在地</th>
							<td class="padding__top-zero">
								<div class="width-trans-item">
									<text-input
										class="contents__input--text width-syozaichi"
										style="ime-mode: active"
										:modelValue="formC1.txSyozaichi"
										:maxLength="20"
										:textType="TEXTINPUT_TYPE.FULL"
										:name="'所在地'"
										:groupId="'txSyozaichi'"
										@update:modelValue="formC1.txSyozaichi = $event"
										ref="txSyozaichi"
										tabindex="35" />
								</div>
								<itemerror-message :groupId="'txSyozaichi'"/>
							</td>
						</tr>
						<tr v-if="disp.isFilterOpen" class="contents__input--tr background__color--light-gray">
							<th class="contents__input--title padding__bottom-zero">名称</th>
							<td class="padding__top-zero">
								<div>
									<text-input
										class="contents__input--text width-syozaichi"
										style="ime-mode: active"
										:modelValue="formC1.txName"
										:maxLength="20"
										:textType="TEXTINPUT_TYPE.FULL"
										:name="'名称'"
										:groupId="'txName'"
										@update:modelValue="formC1.txName = $event"
										ref="txName"
										tabindex="36" />
								</div>
								<itemerror-message :groupId="'txName'"/>
							</td>
						</tr>
						<tr v-if="disp.isFilterOpen"  class="contents__input--tr background__color--white">
							<th class="contents__input--title padding__bottom-zero">電話番号</th>
							<td class="padding__top-zero">
								<div>
									<number-input
										class="contents__input--text width-phone"
										:modelValue="formC1.idTel1"
										:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
										:name="'電話番号（市外）'"
										:maxLength="5"
										:groupId="'tel'"
										@update:modelValue="formC1.idTel1 = $event"
										ref="idTel1"
										tabindex="37"
									/>
									-
									<number-input
										class="contents__input--text width-phone"
										:modelValue="formC1.idTel2"
										:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
										:name="'電話番号（市内）'"
										:maxLength="4"
										:groupId="'tel'"
										@update:modelValue="formC1.idTel2 = $event"
										ref="idTel2"
										tabindex="38"
									/>
									-
									<number-input
										class="contents__input--text width-phone"
										:modelValue="formC1.idTel3"
										:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
										:name="'電話番号（局番）'"
										:maxLength="4"
										:groupId="'tel'"
										@update:modelValue="formC1.idTel3 = $event"
										ref="idTel3"
										tabindex="39"
									/>
								</div>
								<itemerror-message :groupId="'tel'"/>
							</td>
						</tr>
						<tr v-if="disp.isFilterOpen" class="contents__input--tr background__color--light-gray">
							<th class="contents__input--title padding__bottom-zero">勤務（開業）開始日</th>
							<td class="padding__top-zero">
								<div class="width-senyoarea-item">
									<date-input
										:modelValue="formC1.dtYmdStt"
										:name="'勤務（開業）開始日'"
										:dateType="DATE_KIND.KINMU_START"
										:groupId="'dtYmdStt'"
										@update:modelValue="formC1.dtYmdStt = $event"
										ref="dtYmdStt"
										tabindex="40"
									/>
								</div>
								<itemerror-message :groupId="'dtYmdStt'"/>
							</td>
						</tr>
						<tr v-if="disp.isFilterOpen" class="contents__input--tr background__color--white">
							<th class="contents__input--title padding__bottom-zero">職業</th>
							<td class="padding__top-zero">
								<div>
									<list-box
										class="contents__input--select width-auto"
										:modelValue="formC1.cdSyokugyo"
										:name="'職業'"
										:cdType="'L0023'"
										:cdKbn="CD_HANDLE_TYPE.ID_CD"
										:groupId="'cdSyokugyo'"
										@update:modelValue="formC1.cdSyokugyo = $event"
										ref="cdSyokugyo"
										tabindex="43">
									</list-box>
								</div>
								<itemerror-message :groupId="'cdSyokugyo'"/>
							</td>
						</tr>
					</tbody>
				</table>
				<div>
					<br/>
					<h2 class="contents__h2 contents__mosikomi3">都営住宅に同居予定の方（都営住宅に同居予定のすべての方）について入力してください。<span class="nyukyo-title">必須</span></h2>
				</div>
				<div class="contents__caution--div margin__nyukyoList-tyui">
					<div class="contents__caution--div_mark">
						<p class="contents__caution contents__caution--multiple">
							※
						</p>
					</div>
					<div>
						<p class="contents__caution contents__caution--multiple">
							下の同居者入力ボタンを押して、入力してください。
						</p>
					</div>
				</div>
				<div
					v-if="disp.nyukyoNinzuErrFlg"
					class="contents__caution--div div_row error-message-area item-error-margin nyukyo-error">
					<div class="contents__caution--div_mark item-error-icon-margin">
						<p class="contents__caution--error contents__caution--multiple">
							<font-awesome-icon icon="exclamation-triangle" class="error-itemsmsg-icon-size" />
						</p>
					</div>
					<div class="error-msg-list">
						<ul>
							<li>{{ co_getMessage('E0072') }}</li>
						</ul>
					</div>
				</div>
				<div>
					<table  class="list2 border__collapse clear-both">
						<thead>
							<tr id="listheader" class="contents__list font-size">
								<th class="contents__thtd--btn"></th>
								<th class="contents__thtd--btn"></th>
								<th class="contents__table--nyukyo">No</th>
								<th class="contents__table--nyukyo">氏名</th>
								<th class="contents__table--nyukyo">続柄</th>
								<th class="contents__table--nyukyo">年齢</th>
								<th class="contents__table--nyukyo">年間所得金額</th>
								<th class="contents__table--nyukyo">特別控除</th>
							</tr>
						</thead>
						<tbody>
							<tr id="listcountents" v-for="(row, index) in formC1.nyukyoList" :key="row.noNyukyo" class="font-size">
								<td class="contents__thtd--btn">
									<input
										type="button"
										:value="row.isInputCheck ? '同居者入力' : '同居者入力'"
										class="contents__btn--confirm table-button"
										@click="openEditNyukyosya(row.noNyukyo)"
										ref="nyukyoBtn"
										:tabindex="Number(0) < index ? String(Number(44) + (2*index)) : String(Number(44) + 1)">
								</td>
								<td class="contents__thtd--btn">
									<span v-if="row.isInputCheck">
										<input
											type="button"
											value="削除"
											class="contents__btn--cancel table-button"
											@click="deleteNyukyosya(row.noNyukyo)"
											:tabindex="String(Number(45) + (2*index))">
									</span>
									<span v-else>&nbsp;</span>
								</td>
								<td class="contents__table--nyukyo">{{ row.noNyukyo }}</td>
								<td class="text-align-left contents__table--nyukyo">
									<span v-if="row.isInputCheck">
										&nbsp;{{ row.nmName1 }}&nbsp;&nbsp;{{ row.nmName2 }}
									</span>
									<span v-else></span>
								</td>
								<td class="contents__table--nyukyo">
									<span v-if="row.isInputCheck">
										{{ row.nmTudukigara }}
									</span>
									<span v-else>&nbsp;</span>
								</td>
								<td class="contents__table--nyukyo" style="width:215px;">
									<span v-if="row.isInputCheck">
										満{{ co_calcAge(row.dtBirthday) }}歳
									</span>
									<span v-else>&nbsp;</span>
								</td>
								<td class="text-align-right contents__table--nyukyo">
									<span v-if="row.isInputCheck">
										{{ co_commaSeparated(row.moSyotoku) }}円&nbsp;
									</span>
									<span v-else>&nbsp;</span>
								</td>
								<td class="text-align-left contents__table--nyukyo">
									<span v-if="row.isInputCheck">
										&nbsp;{{ row.nmKojto }}
									</span>
									<span v-else>&nbsp;</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div>
					<h2 class="contents__h2 contents__mosikomi3">遠隔地扶養者（申込者又は同居親族の所得税法上の扶養親族で、都営住宅に入居しない方）がいる場合は、その方について入力してください。</h2>
				</div>
				<div class="contents__caution--div margin__nyukyoList-tyui">
					<div class="contents__caution--div_mark">
						<p class="contents__caution contents__caution--multiple">
							※
						</p>
					</div>
					<div>
						<p class="contents__caution contents__caution--multiple">
							下の遠隔地扶養者入力ボタンを押して、入力してください。
						</p>
					</div>
				</div>
				<div>
					<table class="list3 border__collapse clear-both">
						<thead>
							<tr id="listheader" class="contents__list font-size">
								<th class="contents__thtd--btn"></th>
								<th class="contents__thtd--btn"></th>
								<th class="contents__table--nyukyo">No</th>
								<th class="contents__table--nyukyo">氏名</th>
								<th class="contents__table--nyukyo">申込者との関係</th>
								<th class="contents__table--nyukyo">年齢</th>
								<th class="contents__table--nyukyo">特別控除</th>
							</tr>
						</thead>
						<tbody>
							<tr id="listcountents" v-for="(row, index) in formC1.fuyoList" :key="row.noFuyo" class="font-size">
								<td class="contents__thtd--btn">
									<input
										type="button"
										value='遠隔地扶養者入力'
										class="contents__btn--confirm table-button"
										@click="openEditFuyosya(row.noFuyo)"
										ref="fuyoBtn"
										:tabindex="Number(0) < index ? String(Number(86) + (2*index)) : String(Number(86) + 1)">
								</td>
								<td class="contents__thtd--btn">
									<span v-if="row.isInputCheck">
										<input
											type="button"
											value="削除"
											class="contents__btn--cancel table-button"
											@click="deleteFuyosya(row.noFuyo)"
											:tabindex="String(Number(87) + (2*index))">
									</span>
									<span v-else>&nbsp;</span>
								</td>
								<td class="contents__table--nyukyo">{{ row.noFuyo }}</td>
								<td class="text-align-left contents__table--nyukyo">
									<span v-if="row.isInputCheck">
										&nbsp;{{ row.nmFuyoName1 }}&nbsp;&nbsp;{{ row.nmFuyoName2 }}
									</span>
									<span v-else></span>
								</td>
								<td class="contents__table--nyukyo">
									<span v-if="row.isInputCheck">
										{{ row.nmMoukankei }}
									</span>
									<span v-else>&nbsp;</span>
								</td>
								<td class="contents__table--nyukyo" style="width:215px;">
									<span v-if="row.isInputCheck">
										満{{ co_calcAge(row.dtBirthday) }}歳
									</span>
									<span v-else>&nbsp;</span>
								</td>
								<td class="text-align-left contents__table--nyukyo">
									<span v-if="row.isInputCheck">
										&nbsp;{{ row.nmKojto }}
									</span>
									<span v-else>&nbsp;</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<h2 class="contents__h2">世帯の所得金額と家族人数</h2>
				<table class="contents__table--stripe detail" >
					<tbody>
						<tr>
							<th class="contents__input--title">年間所得金額合計(Ａ)</th>
							<td class="contents__syotoku-kazoku">
								{{ co_commaSeparated(formC1.moAllsyotoku) }} 円
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title">特別控除金額(Ｂ)</th>
							<td class="contents__syotoku-kazoku">
								{{ co_commaSeparated(formC1.moAlltokubetu) }} 円
							</td>
						</tr>
						<tr>
							<th  class="contents__input--title">
								世帯の所得金額
								<div class="font-weight-normal">(Ａ)－(Ｂ)</div>
							</th>
							<td class="contents__syotoku-kazoku">
								{{ co_commaSeparated(formC1.moAllsasihiki) }} 円
								<br />
								<caution-message
									:classDiv="'contents__syotoku-tyui'"
									:tyuibunItems="disp.syotokuItems"
								/>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title">家族人数</th>
							<td colspan="3" class="contents__syotoku-kazoku">
								{{ Number(formC1.nuNyukyo) + Number(formC1.fuyoList.filter(item => item.isInputCheck == true).length) }}人
								<div class="contents__caution--div kazoku-ninzu">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple kazokuNizu-tyui">
											※
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple kazokuNizu-tyui">
											家族人数とは、都営住宅に入居する人数に遠隔地扶養者を加えた人数です。
										</p>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<br/>
				<div>
					<div class="bekkyo-title">
						<h2 class="contents__h2">別居予定者（現在申込者と同居しているが、都営住宅に入居せず、別居する予定の方）について入力してください。</h2>
					</div>
					<br>
					<div class="contents__bekkyo-title">
						<div style="margin-left:15px;">現在、申込者と同居している方のなかに、都営住宅には入居しない方（別居予定者）がいますか。
							<span class="contents__hissu bekkyo-title-hissu">必須</span>
						</div>
						<div>
							<toggle-button
								:classDiv="'width-bekkyoUmu'"
								:modelValue="formC1.kbBekkyoyotei"
								:name="'別居予定者の有無'"
								:cdType="'L0055'"
								:groupId="'kbBekkyoyotei'"
								:radioGroupName="'kbBekkyoyotei'"
								:requireFlg="true"
								@update:modelValue="formC1.kbBekkyoyotei = $event"
								ref="kbBekkyoyotei"
								tabindex="131" />
							<br/>
						</div>						
						<div class="margin-bekkyoUmu">
							<itemerror-message :groupId="'kbBekkyoyotei'"/>
						</div>
					</div>
					<div class="contents__bekkyoList" v-if="disp.isBekkyoFlg">
						<div>
							<div class="bekkyoText-tyui">
								<caution-message
									:cdHanyo1="'T0011'"
									:cdHanyo2="formC1.bosyuHoshiki"
								/>
								<div style="line-height:25px; margin-top:20px;">
									<span class="font-size">別居する理由・状況を簡単に入力してください。</span><br>
									<span class="contents__caution" style="padding-left:15px;">例：実家から独立します。両親と別居します。</span>
								</div>
							</div>
							<div class="margin-bekkyoZyokyo">
								<textarea-input
									class="contents__input--text width-bekkyoZyokyo width-textarea"
									:modelValue="formC1.txBekkyozyokyo"
									:maxLength="200"
									:name="'別居状況内容'"
									:groupId="'txBekkyozyokyo'"
									@update:modelValue="formC1.txBekkyozyokyo = $event"
									ref="txBekkyozyokyo"
									tabindex="132" />
							</div>
							<itemerror-message :groupId="'txBekkyozyokyo'"/>
						</div>
					</div>
				</div>
				<br>
				<div>
					<h2 class="contents__h2 height-auto">現在のお住まいについて、入力してください。</h2>
					<table class="contents__table--stripe detail_split" >
						<tbody>
							<tr>
								<th class="contents__input--title width-jyutakuKind-title">住宅の種類<span class="contents__hissu">必須</span></th>
								<td colspan="3" class="width-80per">
									<list-box
										class="contents__input--select"
										:modelValue="formC1.cdNowjyutaku"
										:name="'住宅の種類'"
										:groupId="'cdNowjyutaku'"
										:cdType="'L0019'"
										:requireFlg="true"
										@update:modelValue="changeJyutakuList"
										ref="cdNowjyutaku"
										tabindex="133"
									/>
									<itemerror-message :groupId="'cdNowjyutaku'"/>
									<caution-message
										:tyuibunItems="disp.jyutakuItems"
									/>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="contents__acordion">
						<b><label class="width-acordion">住宅の詳細（資格審査時に確認しますので、申込時点での入力は必須ではありません）</label></b>
						<div class="square-position" @click="detailOpen()">
							<transition name="rotate" mode="out-in">
								<font-awesome-icon :icon="['far', 'minus-square']" v-if="disp.isDetailOpen" key="rotate1"/>
								<font-awesome-icon :icon="['far', 'plus-square']" v-else key="rotate2"/>
							</transition>
						</div>
					</div>
					<transition name="open">
						<div v-if="disp.isDetailOpen">
							<table class="contents__table--stripe detail_split table-border-top" >
								<tbody>
									<tr class="contents__yatin">
										<th class="contents__input--title width-yatin-title">家賃</th>
										<td colspan="3" class="font-size">
											月額 <number-input
													class="contents__input--text width-yatin"
													:modelValue="formC1.moNowyachin"
													:maxLength="6"
													:name="'住宅の月額家賃'"
													:groupId="'moNowyachin'"
													:numberType="NUMBERINPUT_TYPE.PERIOD"
													@update:modelValue="formC1.moNowyachin = $event"
													ref="moNowyachin"
													tabindex="134"
												/> 円
											<itemerror-message :groupId="'moNowyachin'"/>
											<div class="contents__caution--div div_row">
												<div class="contents__caution--div_mark">
													<p class="contents__caution contents__caution--multiple">
													※
													</p>
												</div>
												<div>
													<p class="contents__caution contents__caution--multiple">
														共益費、駐車場料金等を除く。
													</p>
												</div>
											</div>
										</td>
									</tr>
									<tr class="contents__madori">
										<th  class="contents__input--title width-madori-title">間取り</th>
										<td class="width-madori">
											<list-box
												class="contents__input--select"
												:modelValue="formC1.cdNowmadori"
												:name="'住宅の間取り'"
												:groupId="'cdNowmadori'"
												:cdType="'L0052'"
												@update:modelValue="formC1.cdNowmadori = $event"
												ref="cdNowmadori"
												tabindex="135" />
										</td>
										<itemerror-message :groupId="'cdNowmadori'"/>
										<th class="contents__input--title width-tatamisu-title">
											間取りのK・DK・LDKを<br/>
											除いた部分の畳数の合計<br/>
										</th>
										<td class="width-tatamisu">
											合計 <number-input
												class="contents__input--text width-66"
												:modelValue="formC1.nuNowtatamisu"
												:maxLength="2"
												:decimalLength="1"
												:name="'住宅の畳数'"
												:groupId="'nuNowtatamisu'"
												:numberType="NUMBERINPUT_TYPE.INTEGER"
												@update:modelValue="formC1.nuNowtatamisu = $event"
												ref="nuNowtatamisu"
												tabindex="136"
											/> 畳
											<itemerror-message :groupId="'nuNowtatamisu'"/>
											<div></div>
										</td>
									</tr>
									<tr class="contents__senyoArea">
										<th  class="contents__input--title">住戸専用面積</th>
										<td colspan="3" class="narrow_row">
											<div class="font-size">
												<number-input
													class="contents__input--text width-74"
													:modelValue="formC1.nuNowsenyo"
													:maxLength="3"
													:name="'住戸専用面積'"
													:groupId="'nuNowsenyo'"
													:numberType="NUMBERINPUT_TYPE.INTEGER"
													@update:modelValue="formC1.nuNowsenyo = $event"
													ref="nuNowsenyo"
													tabindex="137"
												/> m&sup2;
											</div>
											<div>
												<itemerror-message :groupId="'nuNowsenyo'"/>
											</div>
											<div class="senyoArea-tyui">
												<div class="contents__caution--div div_row senyo-tyui">
													<div class="contents__caution--div_mark">
														<p class="contents__caution contents__caution--multiple">
														※
														</p>
													</div>
													<div>
														<p class="contents__caution contents__caution--multiple">
															住宅が狭いことを理由とした、都営住宅等公的住宅からの申込み及び世帯を分離する申込みの方のみ入力してください。
														</p>
													</div>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</transition>
					<br />
				</div>
				<h2 class="contents__h2">都営住宅に入居する方についてあてはまるものを選択してください。</h2>
				<table class="contents__table--stripe detail" >
					<tbody>
						<tr>
							<th class="contents__input--title">階段の上り下りが困難な方がいますか</th>
							<td>
								<toggle-button
									:modelValue="formC1.kbKaidan"
									:name="'階段困難'"
									:cdType="'L0008'"
									:groupId="'kaidan'"
									:radioGroupName="'kaidan'"
									:disabledFlg="false"
									@update:modelValue="formC1.kbKaidan = $event"
									ref="kbKaidan"
									tabindex="138" />
							</td>
							<itemerror-message :groupId="'kaidan'"/>
						</tr>
						<tr>
							<th class="contents__input--title">それぞれに該当する方がいれば選択してください。（複数回答可）</th>
							<td>
								<div class="contents__div--tokubetu">
									<check-box
										:classDiv="'contents__tokubetu'"
										:modelValue="formC1.fgTokubetu"
										:name="'特別区分'"
										:cdType="'L0056'"
										:cdHanyo1="'1'"
										:groupId="'tokubetu'"
										:classItems="disp.tokubetuClassItems"
										@update:modelValue="formC1.fgTokubetu = $event"
										ref="fgTokubetu"
										tabindex="139"
									/>
								</div>
								<div>
									<itemerror-message :groupId="'tokubetu'"/>
									<caution-message
										:tyuibunItems="disp.tokubetuItems"
									/>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title">心身障害者を含む世帯について該当する方がいれば選択してください。（複数回答可）</th>
							<td>
								<div class="contents__div--tokubetu">
									<check-box
										:classDiv="'contents__tokubetu'"
										:modelValue="formC1.kbShinGaitokomoku"
										:name="'心身障害者該当項目'"
										:cdType="'L0109'"
										:groupId="'shinshin'"
										:classItems="disp.tokubetuClassItems"
										@update:modelValue="formC1.kbShinGaitokomoku = $event"
										ref="kbShinGaitokomoku"
										tabindex="142"
									/>
								</div>
								<div>
									<itemerror-message :groupId="'shinshin'"/>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title">
								住宅や土地を所有している方がいますか
								<span class="contents__hissu">必須</span>
							</th>
							<td>
								<div style="display:block;">
									<div class="contents__totiSyoyu--div">
										<toggle-button
											:modelValue="formC1.kbSyoyu"
											:name="'住宅土地所有'"
											:cdType="'L0009'"
											:groupId="'totiSyoyu'"
											:radioGroupName="'totiSyoyu'"
											:disabledFlg="false"
											:requireFlg="true"
											@update:modelValue="formC1.kbSyoyu = $event"
											ref="kbSyoyu"
											tabindex="146" />
										<br/>
									</div>
									<div>
										<itemerror-message :groupId="'totiSyoyu'"/>
									</div>
									<div>
										<itemerror-message :groupId="'kbSyoyuHosoku'"/>
										<caution-message
											:classDiv="'contents__totisyoyu-tyui'"
											:tyuibunItems="disp.syoyuItems"
										/>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th class="contents__input--title">申込確定にあたっては、以下の事項に誓約・同意することが必要です。<span class="contents__hissu">必須</span></th>
							<td class="padding__top-zero font-size">
								<div class="doui-tyui">
									<seikyu-message
										:tyuibunItems="disp.seiyakuItems"
									/>
								</div>
								<div class="width-seiyakuDoui">
									<check-box
										:classDiv="'font-size'"
										:modelValue="formC1.fgSeiyakuDoui"
										:name="'誓約・同意'"
										:groupId="'fgSeiyakuDoui'"
										:listItems="disp.seiyakuDouiList"
										:requireFlg="true"
										@update:modelValue="formC1.fgSeiyakuDoui = $event"
										ref="fgSeiyakuDoui"
										tabindex="147" />
								</div>
								<itemerror-message :groupId="'fgSeiyakuDoui'"/>
							</td>
						</tr>
					</tbody>
				</table>
				<br />
				<div>
					<h2 class="contents__h2 contents__kiboJyoken">備考（所得額、住宅の条件など、聞きとりした内容）</h2>
					<table class="contents__table--stripe detail">
						<tbody>
							<tr>
								<td class="border__bottom-none">
									<div class="margin__top-9">
										<textarea-input
											class="contents__input--text width-biko width-textarea"
											:modelValue="formC1.txKiboJyoken"
											:maxLength="400"
											:name="'ご希望の住宅の条件'"
											:groupId="'txKiboJyoken'"
											@update:modelValue="formC1.txKiboJyoken = $event"
											ref="txKiboJyoken"
											tabindex="148" />
									</div>
									<itemerror-message :groupId="'txKiboJyoken'"/>
								</td>
							</tr>
						</tbody>
					</table>
					<br />
				</div>
				<div>
					<h2 class="contents__h2" >満足度アンケートのお願い
						<br/>今後のサービス向上のため、下記アンケートにご協力をお願いします。
					</h2>
					<label></label>
					<table class="contents__table--stripe detail" >
						<tbody>
							<tr>
								<th class="contents__input--title">{{ formC1.txAnketo1 }}</th>
								<td class="contents__enquete">
									<div class="contents__div--anketo margin__top-9 margin__left-m14">
										<check-box
											:classDiv="'font-size'"
											:modelValue="formC1.kbAnketo1"
											:name="'上記都営住宅を選んだ理由'"
											:cdType="'L0038'"
											:classItems="disp.anketo1ansClassItems"
											@update:modelValue="formC1.kbAnketo1 = $event"
											ref="kbAnketo1ans"
											tabindex="149"
										/>
									</div>
									<div class="margin__anketo-etc">
										<textarea-input
											class="contents__input--text margin__bottom-8 width-textarea width-enquete1"
											:modelValue="formC1.txAnketo1ansetc"
											:maxLength="400"
											:name="'アンケート回答１その他'"
											:groupId="'txAnketo1ansetc'"
											@update:modelValue="formC1.txAnketo1ansetc = $event"
											ref="txAnketo1ansetc"
											tabindex="150" />
									</div>
								</td>
							</tr>
							<tr>
								<th class="contents__input--title">{{ formC1.txAnketo2 }}</th>
								<td class="contents__enquete">
									<div class="contents__div--anketo margin__top-9 margin-anketo">
										<check-box
											:classDiv="'font-size'"
											:modelValue="formC1.kbAnketo2"
											:name="' 都営住宅のオンライン募集をどのようにお知りになりましたか'"
											:cdType="'L0039'"
											:classItems="disp.anketo2ansClassItems"
											@update:modelValue="formC1.kbAnketo2 = $event"
											ref="kbAnketo2ans"
											tabindex="151"
										/>
									</div>
									<div class="margin__anketo-etc">
										<textarea-input
											class="contents__input--text margin__bottom-8 width-textarea width-enquete2"
											:modelValue="formC1.txAnketo2ansetc"
											:maxLength="400"
											:name="'アンケート回答２その他'"
											:groupId="'txAnketo2ansetc'"
											@update:modelValue="formC1.txAnketo2ansetc = $event"
											ref="txAnketo2ansetc"
											tabindex="152" />
									</div>
								</td>
							</tr>
							<tr>
								<th class="contents__input--title padding__bottom-zero">{{ formC1.txAnketo3 }}</th>
								<td class="padding__top-zero">
									<div >
										<radio-button
											:classDiv="'font-size'"
											:modelValue="formC1.kbAnketo3"
											:name="'オンライン申込を利用しなかった理由'"
											:cdType="'L0094'"
											:radioGroupName="'enquete3'"
											:cdKbn="CD_HANDLE_TYPE.ID_CD"
											:classItem="'width-dairi-enquete3'"
											:disabledFlg="false"
											@update:modelValue="formC1.kbAnketo3 = $event"
											ref="kbAnketo3"
											tabindex="153" />
									</div>
									<div class="contents__caution--div div_row">
										<div class="contents__caution--div_mark">
											<p class="contents__caution contents__caution--multiple">
											※
											</p>
										</div>
										<div>
											<p class="contents__caution contents__caution--multiple">
												「試してみたが難しかった（使いにくかった）」、「その他」を選択された際は具体的な理由を入力してください。
											</p>
										</div>
									</div>
									<div class="margin__anketo-etc">
										<textarea-input
											class="contents__input--text margin__bottom-8 width-textarea width-enquete3"
											:modelValue="formC1.txAnketo3ansetc"
											:maxLength="400"
											:name="'アンケート回答３その他'"
											:groupId="'txAnketo3ansetc'"
											@update:modelValue="formC1.txAnketo3ansetc = $event"
											ref="txAnketo3ansetc"
											tabindex="154" />
									</div>
								</td>
							</tr>
							<tr>
								<th  class="contents__input--title">{{ formC1.txAnketo4 }}</th>
								<td>
									<div>
										<textarea-input
											class="contents__input--text margin__bottom-8 width-textarea width-enquete4"
											:modelValue="formC1.txAnketo4ans"
											:maxLength="400"
											:name="'アンケート回答４'"
											:groupId="'txAnketo4ans'"
											@update:modelValue="formC1.txAnketo4ans = $event"
											ref="txAnketo4ans"
											tabindex="155" />
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div align="center" class="contents__btn-statement">
					<div v-if="disp.itijiHozonFlg" class="contents__caution--multiple btn-statement1">
						<label class="font-size">申込みせずに入力した内容を保存する場合、「一時保存」ボタンをクリックしてください。</label>
					</div>
					<div v-else-if="formC1.transKbn == '1'" class="contents__caution--multiple btn-statement2">
						<label class="font-size">申込みする場合、「申込みへ」ボタンをクリックしてください。</label>
					</div>
					<div v-else class="contents__caution--multiple btn-statement2">
						<label class="font-size">申込みする場合、「申込み内容の確認へ」ボタンをクリックしてください。</label>
					</div>
					<div v-if="formC1.transKbn == '1'" class="contents__caution--multiple btn-statement3">
						<label class="font-size">申込みせず、募集住宅情報（随時募集・管理者用【代理申込み】）画面に戻る場合、「申込み中止」ボタンをクリックしてください。</label>
					</div>
					<div v-else class="contents__caution--multiple btn-statement3">
						<label class="font-size">申込みせず、申込者情報詳細（随時募集・管理者用）画面に戻る場合、「戻る」ボタンをクリックしてください。</label>
					</div>
				</div>
				<div class="contents__div--center margin__bottom-page">
					<input
						type="button"
						value="一時保存"
						class="contents__btn--confirm btn-itiji-hozon"
						tabindex="156"
						@click="clickSaveBtn"
						v-if="disp.itijiHozonFlg"
						/>
					<input
						type="button"
						:value="formC1.transKbn == '1' ? '申込みへ' : '申込み内容の確認へ'"
						class="contents__btn--confirm btn-kakunin"
						tabindex="157"
						@click="clickMosikomiKakuninBtn"/>
					<input
						type="button"
						:value="formC1.transKbn == '1' ? '申込み中止' : '戻る'"
						class="contents__btn--cancel btn-modoru"
						tabindex="158"
						@click="clickBackBtn"/>
				</div>
			</section>
		</div>
	</main>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import TextInput from '@/components/TextInput.vue';
import CautionMessage from '@/components/CautionMessage.vue';
import SeiyakuMessage from '@/components/SeiyakuMessage.vue';
import NumberInput from '@/components/NumberInput.vue';
import ListBox from '@/components/ListBox.vue';
import CheckBox from '@/components/CheckBox.vue';
import RadioButton from '@/components/RadioButton.vue';
import NyukyoNum from '@/components/NyukyoNum.vue';
import ToggleButton from '@/components/ToggleButton.vue';
import DateInput from '@/components/DateInput.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import TextAreaInput from '@/components/TextAreaInput.vue';

import { co_post, co_put, co_setError, co_moveSystemError } from '@/common/ajaxUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js';
import { co_confirmDialog, co_confirmDialog2, co_completedDialog, co_errorDialog, co_errorLinkDialog } from '@/common/dialogUtility.js';
import { co_commaSeparated, co_editDate, co_calcAge } from '@/common/stringUtility.js';
import { co_toTop, co_toTrans, co_toTransCtrl } from '@/common/screenUtility.js';

import { HTTP_STATUS } from '@/const/const.js';
import { DATE_KIND, NUMBERINPUT_TYPE, CD_HANDLE_TYPE, TEXTINPUT_TYPE, DIALOG_BUTTON_LIST_KEY, SEINENSYA_KIJUN_AGE } from '@/const/const.js';
import { STORE_ERROR_CLEAR, STORE_VIEW_PROGRESS, STORE_ERROR_IS_ERRFLG, STORE_ERROR_SET_INPUT_ERR,
			STORE_DATA_DELETE_AT, STORE_DATA_GETDATA, STORE_VIEW_TITLE,
			STORE_ENV_GET_LASTACCESSTIME_UPDATEINTERVAL } from '@/const/store.js';
import { PATH_BC058_INIT, PATH_BC058_GET_MOSIKOMIKBN, PATH_BC058_SAVE_MOSIKOMI, PATH_BC058_CANCEL_MOSIKOMI,
			PATH_BC058_UPDATETIME, API_ADDRESS_INFO, PATH_BC058_CHECK } from '@/const/route.js';
import { E3005 } from '@/const/messageId.js';

export default {
	name: "BC058C1",
	components: {
		'error-message': ErrorMessage,
		'text-input': TextInput,
		'caution-message': CautionMessage,
		'seikyu-message': SeiyakuMessage,
		'number-input': NumberInput,
		'list-box': ListBox,
		'check-box': CheckBox,
		'radio-button': RadioButton,
		'nyukyo-num': NyukyoNum,
		'toggle-button': ToggleButton,
		'date-input': DateInput,
		'itemerror-message': ItemErrorMessage,
		'textarea-input': TextAreaInput,
	},
	props: ['form', 'sourceInfo'],
	data: function () {
		return {
			disp: {
				zyutakuzyohoInfo:[],		// 募集住宅情報
				nyukyoSu: '',				// 入居人数
				noMouchiku: '',				// 申込地区番号
				kbYugu: '',					// 優遇抽せんの有無
				jyutakuName: '',			// 住宅名
				kusicyo: '',				// 代表的な所在地
				trans: '',					// 主な交通機関
				nuBosyukosu: '',			// 募集戸数
				madori: '',					// 間取り
				senyoArea: '',				// 専用面積
				ymkensetu: '',				// 建設年度
				elevatorUmu: '',			// エレベーター
				moSiyoryo: '',				// 使用料
				siyouEtc: '',				// 仕様等
				nuBairitu: '',				// 参考倍率
				jikotaisyo: '',				// 対象階
				jikonaiyo: '',				// 事故内容
				nyukyoLink: '', 			// 入居人数外部リンク
				yuguLink: '',				// 優遇抽せんの有無外部リンク
				jyutakuLink: '',			// 住宅名外部リンク
				syozaitiLink: '',			// 代表的な所在地外部リンク
				transLink: '',				// 主な交通機関外部リンク
				buildLink: '',				// 建設年度外部リンク
				elevatorLink: '',			// エレベーター外部リンク
				shiyoryoLink: '',			// 使用料外部リンク
				shiyoLink: '',				// 仕様等外部リンク
				bairituLink: '',			// 参考倍率外部リンク
				taisyokaiLink: '',			// 対象階外部リンク
				jikoLink: '',				// 事故内容外部リンク
				jyutakuKind: '',			// 住宅の種別
				nmZyutaku: '',				// 住宅の種別名称
				bosyuKind: '',				// 募集の種類
				nmBosyu: '',				// 募集の種類名称
				listHideKbn: 0, 			// 一覧非表示区分(1:参考倍率、2：対象階・事故内容、3：すべて)
				sinseiItems: ['C0003'], 	// 申請注意文
				seiyakuDouiList: [],		// 誓約・同意リスト
				mouKbnList: [], 			// 申込区分リスト
				isDetailOpen: false,		// 住宅の詳細開閉フラグ
				dokyoItems: ['C0081'],		// 同居人数注意文
				nyukyoItems1: ['C0020'],	// 入居人数注意文１
				mouItems1: [],				// 申込区分注意文１
				ageItems1: [],				// 年齢注意文１
				ageItems2: [],				// 年齢注意文２
				zairyuItems: [],			// 在留資格注意文
				syotokuItems: ['C0031'],	// 所得金額注意文
				jyutakuItems: [],			// 現在の住宅の種類注意文
				tokubetuItems: ['C0220'],	// 特別区分注意文
				syoyuItems: [],				// 住宅土地所有注意文
				seiyakuItems: ['C0027'],	// 制約・同意注意文
				anketo1ansClassItems: [],	// アンケート１回答スタイル
				anketo2ansClassItems: [],	// アンケート２回答スタイル
				itijiHozonFlg: true,		// 一時保存ボタン制御フラグ
				nyukyoNinzuErrFlg: false,	// 入居人数エラーフラグ
				isBekkyoFlg: false,			// 別居予定者情報表示フラグ
				task: '',					// 最終アクセス時間更新タスク
				syotoku1Items: ['C0034'],	// 年間所得注意文１リスト
				syotoku2Items: ['C0184'],	// 年間所得注意文２リスト
				kojto1Items: ['C0030'],		// 特別控除注意文１リスト
				kojto2Items: ['C0185'],		// 特別控除注意文２リスト
				isFilterOpen: false,		// 絞り込み開閉フラグ
				tokubetuClassItems: [],		// 特別区分スタイル
				linkInfo1: '',				// 所得基準表URL
				linkInfo2: '',				// 都民住宅URL
				linkInfo3: '',				// 公社住宅URL
			},
			formC1: [],						// 入力FORM
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			CD_HANDLE_TYPE: CD_HANDLE_TYPE,
			DATE_KIND: DATE_KIND,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE,
			SEINENSYA_KIJUN_AGE: SEINENSYA_KIJUN_AGE,
			co_commaSeparated: co_commaSeparated,
			co_editDate: co_editDate,
			co_calcAge: co_calcAge,
			co_getMessage: co_getMessage,
			co_isEmpty: co_isEmpty,
			deleteNoNyukyo: 0,
			deleteNoFuyo: 0
		}
	},
	mounted: async function () {
		await this.$nextTick();

		if (this.$route.fullPath.indexOf('#BC058C1') == -1) {
			// 初期表示時
			// フォーカス設定
			this.$refs.nuDoukyo.focus();

			// ページトップへ遷移
			co_toTop();
		} else {
			if (this.sourceInfo.transKbn == '2') {
				// 同居者入力画面からの戻り
				// フォーカス設定
				this.$refs.nyukyoBtn[this.sourceInfo.selectNo].focus();

			} else if (this.sourceInfo.transKbn == '3') {
				// 遠隔地扶養者入力画面からの戻り
				// フォーカス設定
				this.$refs.fuyoBtn[0].focus();
			} 
		} 
	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 同機能内のパラメータ受け渡し
		this.formC1 = this.form;

		// 画面タイトル
		if (this.formC1.transKbn == '3') {
			this.$store.commit(STORE_VIEW_TITLE, '世帯情報変更（随時募集・管理者用【代理申込み】）');
		} else {
			this.$store.commit(STORE_VIEW_TITLE, '世帯情報入力（随時募集・管理者用【代理申込み】）');
		}

		// 制約・同意
		this.disp.seiyakuDouiList = [
			{ idCd: '1', nmCd: '上記について誓約・同意する'}
		];

		// アンケート回答１クラスリスト
		this.disp.anketo1ansClassItems= ['width-enquete7-column1'
										,'width-enquete7-column2'
										,'width-enquete7-column3'
										,'width-enquete7-column4'
										,'width-enquete7-column5'
										,'width-enquete7-column6'
										,'width-enquete7-column7'
										,'width-enquete7-column8'
										,'width-enquete7-column9'
										,'width-enquete7-column10'
										,'width-enquete7-column11'
										,'width-enquete7-column12'
										,'width-enquete7-long1'
										,'width-enquete7-long2'];

		// アンケート回答２クラスリスト
		this.disp.anketo2ansClassItems= ['width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8'
										,'width-enquete8-long'
										,'width-enquete8'];

		// 特別区分クラスリスト
		this.disp.tokubetuClassItems =	['margin-tokubetu1'
										,'margin-tokubetu2'
										,'margin-tokubetu3'
										,'margin-tokubetu4'];

		// 成年者基準年齢設定
		this.formC1.seinensyaAge = SEINENSYA_KIJUN_AGE;

		// 前画面からの住宅情報を設定
		this.disp.nyukyoSu = this.formC1.zyutakuInfo.nyukyoSu.trim();
		this.disp.noMouchiku = this.formC1.zyutakuInfo.noMouchiku;
		this.disp.kbYugu = this.formC1.zyutakuInfo.kbYugu;
		this.disp.jyutakuName = this.formC1.zyutakuInfo.jyutakuName;
		this.disp.kusicyo = this.formC1.zyutakuInfo.kusicyo;
		this.disp.trans = this.formC1.zyutakuInfo.trans;
		this.disp.nuBosyukosu = this.formC1.zyutakuInfo.nuBosyukosu;
		this.disp.madori = this.formC1.zyutakuInfo.madori;
		this.disp.senyoArea = this.formC1.zyutakuInfo.senyoArea;
		this.disp.ymkensetu = this.formC1.zyutakuInfo.ymkensetu;
		this.disp.elevatorUmu = this.formC1.zyutakuInfo.elevatorUmu;
		this.disp.moSiyoryo = this.formC1.zyutakuInfo.moSiyoryo;
		this.disp.siyouEtc = this.formC1.zyutakuInfo.siyouEtc;
		this.disp.nuBairitu = this.formC1.zyutakuInfo.nuBairitu;
		this.disp.jikotaisyo = this.formC1.zyutakuInfo.jikotaisyo;
		this.disp.jikonaiyo = this.formC1.zyutakuInfo.jikonaiyo;
		this.disp.nmZyutaku = this.formC1.zyutakuInfo.nmZyutaku;
		this.disp.nmBosyu = this.formC1.zyutakuInfo.nmBosyu;
		this.disp.nyukyoLink = this.formC1.zyutakuInfo.nyukyoLink;
		this.disp.yuguLink = this.formC1.zyutakuInfo.yuguLink;
		this.disp.jyutakuLink = this.formC1.zyutakuInfo.jyutakuLink;
		this.disp.syozaitiLink = this.formC1.zyutakuInfo.syozaitiLink;
		this.disp.transLink = this.formC1.zyutakuInfo.transLink;
		this.disp.buildLink = this.formC1.zyutakuInfo.buildLink;
		this.disp.elevatorLink = this.formC1.zyutakuInfo.elevatorLink;
		this.disp.shiyoryoLink = this.formC1.zyutakuInfo.shiyoryoLink;
		this.disp.shiyoLink = this.formC1.zyutakuInfo.shiyoLink;
		this.disp.bairituLink = this.formC1.zyutakuInfo.bairituLink;
		this.disp.taisyokaiLink = this.formC1.zyutakuInfo.taisyokaiLink;
		this.disp.jikoLink = this.formC1.zyutakuInfo.jikoLink;

		// 初回表示のみ実行
		if (this.formC1.kbKoubo == '') {
			// 初期表示情報取得
			let self = this;
			let param = {
				'kbBosyu'		: this.formC1.kbBosyu.substring(0, 2),
				'kbZyutaku'		: this.formC1.kbZyutaku,
				'ymBosyu'		: this.formC1.ymBosyu,
				'noMouchiku'	: this.formC1.noMouchiku,
				'noRenzoku' 	: this.formC1.noRenzoku
			};

			let mosikomiInfo = await co_post(PATH_BC058_INIT, param, function (res, handle) {
				if (res.status == HTTP_STATUS.OK) {
					return handle(res);
				} else {
					// ローディング表示終了
					self.$store.commit(STORE_VIEW_PROGRESS, false);
				}
			});

			if (mosikomiInfo != null) {
				if (mosikomiInfo.mosikomiZyutakuInfo != null) {
					// 住宅情報設定
					this.formC1.zyutakuInfo['cdNyukyo'] = mosikomiInfo.mosikomiZyutakuInfo.cdNyukyo;
					this.formC1.zyutakuInfo['nmNyukyoLow'] = mosikomiInfo.mosikomiZyutakuInfo.nmNyukyoLow;
					this.formC1.zyutakuInfo['nmNyukyoUpr'] = mosikomiInfo.mosikomiZyutakuInfo.nmNyukyoUpr;
					this.formC1.zyutakuInfo['dtKijun7'] = mosikomiInfo.mosikomiZyutakuInfo.dtKijun7;
					this.formC1.zyutakuInfo['dtBosyuStt'] = mosikomiInfo.mosikomiZyutakuInfo.dtBosyuStt;
					this.formC1.zyutakuInfo['dtYusouEnd'] = mosikomiInfo.mosikomiZyutakuInfo.dtYusouEnd;
					this.formC1.zyutakuInfo['kbYuguFg'] = mosikomiInfo.mosikomiZyutakuInfo.kbYugu;

					this.formC1.kbKoubo = mosikomiInfo.mosikomiZyutakuInfo.kbKoubo;
					this.formC1.dtBosyuStt = mosikomiInfo.mosikomiZyutakuInfo.dtBosyuStt;
					this.formC1.dtYusouEnd = mosikomiInfo.mosikomiZyutakuInfo.dtYusouEnd;
					this.formC1.dtCyusenno = mosikomiInfo.mosikomiZyutakuInfo.dtCyusenno;
					this.formC1.dtCyusen = mosikomiInfo.mosikomiZyutakuInfo.dtCyusen;
					this.formC1.dtCyusenkeka = mosikomiInfo.mosikomiZyutakuInfo.dtCyusenkeka;
					this.formC1.mosikomiLinkItems = [mosikomiInfo.mosikomiZyutakuInfo.txMosikomiLink];
					this.formC1.bosyuHoshiki = mosikomiInfo.mosikomiZyutakuInfo.bosyuHoshiki;

					if (co_isEmpty(this.formC1.nuNyukyo)) {
						// 入居人数未設定の場合、入居人数下限値を設定
						this.formC1.nuNyukyo = mosikomiInfo.mosikomiZyutakuInfo.nmNyukyoLow;
					}
				}

				if (mosikomiInfo.anketoAnswerInfo != null
					&& (this.formC1.txAnketo1 == null || this.formC1.txAnketo1 == '' )) {
					// アンケート回答設定
					this.formC1.kbAnketo1 = mosikomiInfo.anketoAnswerInfo.kbAnketo1;
					this.formC1.txAnketo1ansetc = mosikomiInfo.anketoAnswerInfo.txAnketo1ansetc;
					this.formC1.kbAnketo2 = mosikomiInfo.anketoAnswerInfo.kbAnketo2;
					this.formC1.txAnketo2ansetc = mosikomiInfo.anketoAnswerInfo.txAnketo2ansetc;
					this.formC1.kbAnketo3 = mosikomiInfo.anketoAnswerInfo.kbAnketo3;
					this.formC1.txAnketo3ansetc = mosikomiInfo.anketoAnswerInfo.txAnketo3ansetc;
					this.formC1.txAnketo4ans = mosikomiInfo.anketoAnswerInfo.txAnketo4ans;
				}

				if (mosikomiInfo.anketoHyodaiInfo != null) {
					// アンケート表題設定
					this.formC1.txAnketo1 = mosikomiInfo.anketoHyodaiInfo.nmAnketo1;
					this.formC1.txAnketo2 = mosikomiInfo.anketoHyodaiInfo.nmAnketo2;
					this.formC1.txAnketo3 = mosikomiInfo.anketoHyodaiInfo.nmAnketo3;
					this.formC1.txAnketo4 = mosikomiInfo.anketoHyodaiInfo.nmAnketo4;
				}

				// 保存期間日時
				this.formC1.dtHozon = mosikomiInfo.hozonDate;

				// 所得金額超過エラーURLリスト
				this.formC1.syotokuErrUrlList = mosikomiInfo.urlList;

				let mosikomiData = this.$store.getters[STORE_DATA_GETDATA]('BC058');
				if (this.formC1.transKbn != '2' && this.formC1.transKbn != '3') {
					if (mosikomiData == null) {
						// 同居者リスト設定
						this.$emit('addNyukyosya', 1);
						// 遠隔地扶養者リスト設定
						this.$emit('addFuyosya', 1);
					}
				}
			}
		}

		await this.$nextTick();

		this.$refs.dtMoubirthday.setValue(this.formC1.dtMoubirthday);
		this.$refs.dtZairyuStt.setValue(this.formC1.dtZairyuStt);
		this.$refs.dtZairyuEnd.setValue(this.formC1.dtZairyuEnd);

		// 表示項目制御
		this.formC1.kbMosikomi = '001';
		if (this.formC1.kbZyutaku == '23') {
			this.disp.listHideKbn = 1;
		} else {
			this.disp.listHideKbn = 3;
		}

		// 申込区分リスト取得、同居者一覧設定
		this.changenuNyukyo(this.formC1.nuNyukyo);

		// 住宅土地所有・理由制御
		if (this.formC1.kbSyoyu == '2') {
			this.disp.syoyuItems = ['C0218'];
		}

		// 年齢注意文１
		this.disp.ageItems1 = ['C0223'];

		// 年齢注意文２
		if (!co_isEmpty(this.formC1.dtMoubirthday) && this.formC1.dtMoubirthday.length == 8) {
			if (!co_isEmpty(this.formC1.zyutakuInfo.dtKijun7)) {
				if (this.formC1.zyutakuInfo.dtKijun7 < this.formC1.dtMoubirthday) {
					this.disp.ageItems2 = ['C0023'];
				}
			} else {
				if (co_calcAge(this.formC1.dtMoubirthday) < this.formC1.seinensyaAge) {
					this.disp.ageItems2 = ['C0023'];
				}
			}
		}

		// 在留資格注意文
		if (this.formC1.kbZairyusikaku == '6'){
			this.disp.zairyuItems = ['C0024'];
		}

		// 遠隔地扶養者一覧の追加
		this.addFuyosyaList();

		// 現在の住宅の種類注意文
		this.changeJyutakuList(this.formC1.cdNowjyutaku);

		// 別居予定者制御
		if (this.formC1.kbBekkyoyotei == '1'){
			this.disp.isBekkyoFlg = true;
		}

		// 一時保存ボタン制御
		if (this.formC1.transKbn == '3' && (!co_isEmpty(this.formC1.cdStatus) && this.formC1.cdStatus != '1')){
			this.disp.itijiHozonFlg = false;
		}

		// 所得金額超過エラーURLを設定
		this.disp.linkInfo1 = this.formC1.syotokuErrUrlList[0].nmCd
		this.disp.linkInfo2 = this.formC1.syotokuErrUrlList[1].nmCd
		this.disp.linkInfo3 = this.formC1.syotokuErrUrlList[2].nmCd

		// 画面の状態管理情報を削除
		this.$store.commit(STORE_DATA_DELETE_AT, 'BC058');

		// 最終アクセス時間更新処理
		let interval = this.$store.getters[STORE_ENV_GET_LASTACCESSTIME_UPDATEINTERVAL];
		this.disp.task = setInterval(async () => {
			await co_put(PATH_BC058_UPDATETIME);
		}, interval);

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	beforeUnmount: function() {
		// 最終アクセス時間更新破棄
		clearInterval(this.disp.task);

		// BC058Pへデータ変更を通知
		this.$emit("data-changed", this.formC1);
	},
	watch: {
		// 生年月日変更
		'formC1.dtMoubirthday' : function () {

			this.disp.ageItems2 = new Array();
			if (this.formC1.dtMoubirthday.length == 8) {
				if (!co_isEmpty(this.formC1.zyutakuInfo.dtKijun7)) {
					if (this.formC1.zyutakuInfo.dtKijun7 < this.formC1.dtMoubirthday) {
						this.disp.ageItems2.push('C0023');
					}
				} else {
					if (co_calcAge(this.formC1.dtMoubirthday) < this.formC1.seinensyaAge) {
						this.disp.ageItems2.push('C0023');
					}
				}
			}
		},
		// 在留資格リスト変更
		'formC1.kbZairyusikaku' : function () {

			this.disp.zairyuItems = new Array();
			if (this.formC1.kbZairyusikaku == '6') {
				this.disp.zairyuItems.push('C0024');
			}
		},
		// 住宅土地所有選択
		'formC1.kbSyoyu' : function () {

			this.disp.syoyuItems = new Array();
			if (this.formC1.kbSyoyu == '2') {
				this.disp.syoyuItems.push('C0218');
			}
		},
		// 別居予定者有無選択
		'formC1.kbBekkyoyotei' : function () {

			if (this.formC1.kbBekkyoyotei == '1'){
				this.disp.isBekkyoFlg = true;
			} else {
				this.disp.isBekkyoFlg = false;
				this.formC1.txBekkyozyokyo = "";
			}
		},
		// 申込者特別控除
		'formC1.fgKojto' : function () {

			// 世帯の所得金額計算
			this.$emit('clacAmount');
		},
	},
	methods: {
		// 入居人数変更
		changenuNyukyo : async function (nuNyukyo) {

			this.formC1.nuNyukyo = nuNyukyo;

			// 申込区分リスト取得
			this.getMosikomiKbn();

			// 同居者リスト追加
			// ※未入力の行がない場合のみ行追加を行う。
			let notCheckCnt = Number(this.formC1.nyukyoList.filter(item => !item.isInputCheck).length);
			if (Number(nuNyukyo - 1) > this.formC1.nyukyoList.length && notCheckCnt == 0) {
				this.$emit('addNyukyosya', this.formC1.nyukyoList.length + 1);
			}

			// 同居者リスト削除
			// ※未入力の行のみリスト削除は行わない
			if (Number(nuNyukyo - 1) < this.formC1.nyukyoList.length && notCheckCnt > 0) {
				this.$emit('deleteNyukyosya', this.formC1.nyukyoList.length);
			}
		},
		// 「住宅の詳細」バー開閉処理
		detailOpen : function () {
			this.disp.isDetailOpen = !this.disp.isDetailOpen;
		},
		// 住所検索
		searchZyusyo : async function () {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// 住所検索
			let zipCodeInfo = {
				'zipcode' : this.formC1.noMouzip1 + this.formC1.noMouzip2
			};
			this.formC1.txMouadr1 = await co_post(API_ADDRESS_INFO, zipCodeInfo);

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);
		},
		// 住宅変更ボタン押下
		clickJyutakuHenko : function () {

			// エラーメッセージ表示
			co_errorDialog(co_getMessage('E0104'), this.doJyutakuHenko);
		},
		// 住宅変更ボタン押下後
		doJyutakuHenko: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},
		// 申込区分リスト変更
		changeMosikomiList : function (val) {

			this.formC1.kbMosikomi = val;

			if (!co_isEmpty(this.formC1.kbMosikomi)) {
				let index = this.disp.mouKbnList.findIndex(item => item.cdHanyo1 === this.formC1.kbMosikomi);
				if (index >= 0) {
					this.formC1.nmMosikomi = this.disp.mouKbnList[index].nmCd;
					this.formC1.mouItems1cdHanyo2 = this.disp.mouKbnList[index].idCd;
					this.formC1.cdYugu = this.disp.mouKbnList[index].cdHanyo3;
				}
			} else {
				this.formC1.nmMosikomi = '';
				this.formC1.mouItems1cdHanyo2 = '';
				this.formC1.cdYugu = '';
			}
		},
		// 在留資格リスト変更
		changeZairyuList : function (val) {

			this.formC1.kbZairyusikaku = val;

			let zairyuItems = new Array();
			if(this.formC1.kbZairyusikaku == '6'){
				zairyuItems.push('C0024');
			}
			this.disp.zairyuItems = zairyuItems;

			if (this.formC1.kbZairyusikaku == '' || this.formC1.kbZairyusikaku == '3') {
				this.$refs.dtZairyuStt.setValue("");
				this.$refs.dtZairyuEnd.setValue("");
			}
		},
		// 遠隔地扶養者リスト追加
		addFuyosyaList: function () {
			// ※未入力の行がない場合のみ行追加を行う
			let notCheckCnt = Number(this.formC1.fuyoList.filter(item => !item.isInputCheck).length);
			let count = this.formC1.fuyoList.length;
			if (notCheckCnt == 0 && count < 20) {
				this.$emit('addFuyosya', count + 1);
			}
		},
		// 現在の住宅の種類リスト変更
		changeJyutakuList : function (val) {

			this.formC1.cdNowjyutaku = val;

			let jyutakuItems = new Array();
			if(this.formC1.cdNowjyutaku == '6' || this.formC1.cdNowjyutaku == '13') {
				jyutakuItems.push('C0026');
			}
			this.disp.jyutakuItems = jyutakuItems;
		},
		// 同居者入力画面遷移
		openEditNyukyosya : function (noNyukyo) {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			this.$router.push({hash: '#BC058C2', params:{ noNyukyo: noNyukyo }});
			co_toTransCtrl();

		},
		// 同居者情報削除
		deleteNyukyosya : function (noNyukyo) {
			this.deleteNoNyukyo = noNyukyo;
			// 確認メッセージ表示
			co_confirmDialog(co_getMessage('W0008'), this.doDeleteNyukyosya);
		},
		// 同居者情報削除実行
		doDeleteNyukyosya : function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 同居者情報削除
				this.$emit('deleteNyukyosya', this.deleteNoNyukyo);
			}
		},
		// 遠隔地扶養者入力画面遷移
		openEditFuyosya : function (noFuyo) {
			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			this.$router.push({hash: '#BC058C3', params:{ noFuyo: noFuyo }});
			co_toTransCtrl();
		},
		// 遠隔地扶養者情報削除
		deleteFuyosya : function (noFuyo) {
			this.deleteNoFuyo = noFuyo;
			// 確認メッセージ表示
			co_confirmDialog(co_getMessage('W0008'), this.doDeleteFuyosya);
		},
		// 遠隔地扶養者情報削除実行
		doDeleteFuyosya : function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 扶養者情報削除
				this.$emit('deleteFuyosya', this.deleteNoFuyo);
			}
		},
		// 一時保存ボタン押下
		clickSaveBtn : async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 単項目チェック処理
			if (!await this.checkInputSave()) {
				// 処理終了
				return;
			} 

			// 世帯の所得金額計算
			this.$emit('clacAmount');

			// 確認メッセージ表示
			co_confirmDialog(co_getMessage('W0005'), this.doMosikomiSave);

		},
		// 申込みへボタン押下
		clickMosikomiKakuninBtn : async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// 単項目チェック処理
			if (!await this.checkInputSingle()) {
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;
			} 

			// 相関チェック処理
			if (!await this.checkInputMultiple()) {
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;
			}

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// 世帯の所得金額計算
			this.$emit('clacAmount');

			// 確認メッセージ表示
			co_confirmDialog2(co_getMessage('I0006'), this.doMosikomiKakunin);

		},
		// 戻るボタン押下
		// 申込み中止ボタン押下
		clickBackBtn : function () {

			// 一時保存状態の場合
			if (this.formC1.transKbn == '1') {
				co_confirmDialog(co_getMessage('W0019'), this.doReleaseBack);
			} else {
				// 申込者情報詳細（随時募集・管理者用）画面に遷移
				co_toTrans('BC061');
			}
		},
		// 一時保存処理
		doMosikomiSave : async function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				let saveResult = false;
				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);
				
				let data = await co_put(PATH_BC058_SAVE_MOSIKOMI, this.formC1, function (res, handle) {

					// 一時保存処理：正常終了
					if(res.status == HTTP_STATUS.CREATED) {
						saveResult = true;
						return handle(res);
					} else {
						// 業務エラー表示
						co_setError(res.data, this.$refs);

						// プログレスバー非表示
						this.$store.commit(STORE_VIEW_PROGRESS, false);
						return;
					}
				});

				this.formC1.noRenzoku = data.noRenzoku;

				if (saveResult) {
					// プログレスバー非表示
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// 完了メッセージ表示
					co_completedDialog(co_getMessage('I0033', this.formC1.dtHozon), this.doCompletion);
				}
			}
		},
		// 仮押さえ解除（戻るボタン押下）
		doReleaseBack : async function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				let cancelResult = false;
				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				// 申込情報
				let mosikomiInfo = {
					'kbBosyu' : this.formC1.kbBosyu,
					'ymBosyu' : this.formC1.ymBosyu,
					'noRenzoku' : this.formC1.noRenzoku
				};
				await co_put(PATH_BC058_CANCEL_MOSIKOMI, mosikomiInfo, function (res, handle) {

					// 一時保存処理：正常終了
					if(res.status == HTTP_STATUS.CREATED) {
						cancelResult = true;
						return handle(res);
					} else {
						// 業務エラー表示
						co_setError(res.data, this.$refs);

						// プログレスバー非表示
						this.$store.commit(STORE_VIEW_PROGRESS, false);
						return;
					}
				});

				if (cancelResult) {
					// プログレスバー非表示
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// 募集住宅検索（随時募集・管理者用【代理申込み】）画面に遷移
					co_toTrans('BC055');
				}
			}
		},
		// 申込み情報一時保存完了
		doCompletion : function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},
		// 申込み内容の確認画面遷移
		doMosikomiKakunin : function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// 申込み内容の確認画面に遷移
				let params = { mosikomiInfo: this.formC1 };
				co_toTrans('BC059', params);
			}
		},
		// 申込区分取得
		getMosikomiKbn : async function () {

			if( typeof this.formC1.zyutakuInfo.kbYuguFg === 'undefined'){
				return;
			}

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let param = {
				'kbBosyu'	: this.formC1.kbBosyu.substring(2),
				'kbZyutaku'	: this.formC1.kbZyutaku,
				'nuNyukyo'	: this.formC1.nuNyukyo,
				'kbYugu'	: this.formC1.zyutakuInfo.kbYuguFg,
				'fgHisaisetai' : '',
				'cdHisainaiyou' : ''
			};

			let mosikomiKbnInfo = await co_post(PATH_BC058_GET_MOSIKOMIKBN, param);
			if (mosikomiKbnInfo != null) {

				// 申込区分リスト設定
				this.disp.mouKbnList = mosikomiKbnInfo;

				// 申込区分リストに申込区分選択値がない場合、申込区分選択値を初期化
				let flg = false;
				for (let i = 0; i < mosikomiKbnInfo.length; i++) {
					if (mosikomiKbnInfo[i].cdHanyo1 == this.formC1.kbMosikomi) {
						flg = true;
					}
				}
				if (!flg) {
					this.formC1.kbMosikomi = '';
				}

				// 申込区分注意文１
				this.changeMosikomiList(this.formC1.kbMosikomi);
			}
			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

		},
		// 一時保存時単項目チェック
		checkInputSave : async function () {

			this.disp.nyukyoNinzuErrFlg = false;

			if (!co_isEmpty(this.formC1.nuDoukyo)) this.$refs.nuDoukyo.validate();
			if (!co_isEmpty(this.formC1.nuNyukyo)) this.$refs.nuNyukyo.validate();
			if (!co_isEmpty(this.formC1.kbMosikomi)) this.$refs.kbMosikomi.validate();
			if (!co_isEmpty(this.formC1.nmMouname1)) this.$refs.nmMouname1.validate();
			if (!co_isEmpty(this.formC1.nmMouname2)) this.$refs.nmMouname2.validate();
			if (!co_isEmpty(this.formC1.nmMoukana1)) this.$refs.nmMoukana1.validate();
			if (!co_isEmpty(this.formC1.nmMoukana2)) this.$refs.nmMoukana2.validate();
			if (!co_isEmpty(this.formC1.nmMoutusyoname1)) this.$refs.nmMoutusyoname1.validate();
			if (!co_isEmpty(this.formC1.nmMoutusyoname2)) this.$refs.nmMoutusyoname2.validate();
			if (!co_isEmpty(this.formC1.nmMoutusyokana1)) this.$refs.nmMoutusyokana1.validate();
			if (!co_isEmpty(this.formC1.nmMoutusyokana2)) this.$refs.nmMoutusyokana2.validate();
			if (!co_isEmpty(this.formC1.dtMoubirthday)) this.$refs.dtMoubirthday.validate();

			if (!co_isEmpty(this.formC1.noMouzip1) || !co_isEmpty(this.formC1.noMouzip2)) {
				this.$refs.noMouzip1.validate();
				this.$refs.noMouzip2.validate();
			}

			if (!co_isEmpty(this.formC1.txMouadr1)) this.$refs.txMouadr1.validate();
			if (!co_isEmpty(this.formC1.txMouadr2)) this.$refs.txMouadr2.validate();
			if (!co_isEmpty(this.formC1.txMouadr3)) this.$refs.txMouadr3.validate();

			if (!co_isEmpty(this.formC1.idMoutel1)
				|| !co_isEmpty(this.formC1.idMoutel2)
				|| !co_isEmpty(this.formC1.idMoutel3)) {
				this.$refs.idMoutel1.validate();
				this.$refs.idMoutel2.validate();
				this.$refs.idMoutel3.validate();
			} 

			if (!co_isEmpty(this.formC1.nuKyojyu)) this.$refs.nuKyojyu.validate();
			if (!co_isEmpty(this.formC1.kbZairyusikaku)) this.$refs.kbZairyusikaku.validate();
			if (!co_isEmpty(this.formC1.dtZairyuStt)) this.$refs.dtZairyuStt.validate();
			if (!co_isEmpty(this.formC1.dtZairyuEnd)) this.$refs.dtZairyuEnd.validate();
			if (!co_isEmpty(this.formC1.moSyotoku)) this.$refs.moSyotoku.validate();
			if (!co_isEmpty(this.formC1.fgKojto)) this.$refs.fgKojto.validate();

			// アコーディオン（申込日時点の勤務先又は学校の名称・所在地）を開く
			this.disp.isFilterOpen = true;
			await this.$nextTick();
			this.$refs.dtYmdStt.setValue(this.formC1.dtYmdStt, false);

			if (!co_isEmpty(this.formC1.txSyozaichi)) this.$refs.txSyozaichi.validate();
			if (!co_isEmpty(this.formC1.txName)) this.$refs.txName.validate();
			if (!co_isEmpty(this.formC1.idTel1)) this.$refs.idTel1.validate();
			if (!co_isEmpty(this.formC1.idTel2)) this.$refs.idTel2.validate();
			if (!co_isEmpty(this.formC1.idTel3)) this.$refs.idTel3.validate();
			if (!co_isEmpty(this.formC1.dtYmdStt)) this.$refs.dtYmdStt.validate();
			if (!co_isEmpty(this.formC1.cdSyokugyo)) this.$refs.cdSyokugyo.validate();

			if (!co_isEmpty(this.formC1.kbKaidan)) this.$refs.kbKaidan.validate();
			if (!co_isEmpty(this.formC1.kbSyoyu)) this.$refs.kbSyoyu.validate();
			if (!co_isEmpty(this.formC1.kbBekkyoyotei)) this.$refs.kbBekkyoyotei.validate();
			if (!co_isEmpty(this.formC1.txKiboJyoken)) this.$refs.txKiboJyoken.validate();
			if (!co_isEmpty(this.formC1.fgTokubetu)) this.$refs.fgTokubetu.validate();
			if (!co_isEmpty(this.formC1.kbShinGaitokomoku)) this.$refs.kbShinGaitokomoku.validate();

			// アコーディオン（住宅の詳細）を開く
			this.disp.isDetailOpen = true;
			await this.$nextTick();

			if (this.disp.isBekkyoFlg) {
				if (!co_isEmpty(this.formC1.txBekkyozyokyo)) this.$refs.txBekkyozyokyo.validate();
			}
			if (!co_isEmpty(this.formC1.cdNowjyutaku)) this.$refs.cdNowjyutaku.validate();
			if (!co_isEmpty(this.formC1.moNowyachin)) this.$refs.moNowyachin.validate();
			if (!co_isEmpty(this.formC1.cdNowmadori)) this.$refs.cdNowmadori.validate();
			if (!co_isEmpty(this.formC1.nuNowtatamisu)) this.$refs.nuNowtatamisu.validate();
			if (!co_isEmpty(this.formC1.nuNowsenyo)) this.$refs.nuNowsenyo.validate();
			if (!co_isEmpty(this.formC1.fgSeiyakuDoui)) this.$refs.fgSeiyakuDoui.validate();
			if (!co_isEmpty(this.formC1.kbAnketo1ans)) this.$refs.kbAnketo1ans.validate();
			if (!co_isEmpty(this.formC1.txAnketo1ansetc)) this.$refs.txAnketo1ansetc.validate();
			if (!co_isEmpty(this.formC1.kbAnketo2ans)) this.$refs.kbAnketo2ans.validate();
			if (!co_isEmpty(this.formC1.txAnketo2ansetc)) this.$refs.txAnketo2ansetc.validate();
			if (!co_isEmpty(this.formC1.kbAnketo3)) this.$refs.kbAnketo3.validate();
			if (!co_isEmpty(this.formC1.txAnketo3ansetc)) this.$refs.txAnketo3ansetc.validate();
			if (!co_isEmpty(this.formC1.txAnketo4ans)) this.$refs.txAnketo4ans.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			return true;
		},
		// 単項目チェック
		checkInputSingle : async function () {

			this.disp.nyukyoNinzuErrFlg = false;

			this.$refs.nuDoukyo.validate();
			this.$refs.nuNyukyo.validate();
			this.$refs.kbMosikomi.validate();
			this.$refs.nmMouname1.validate();
			this.$refs.nmMouname2.validate();
			this.$refs.nmMoukana1.validate();
			this.$refs.nmMoukana2.validate();
			this.$refs.nmMoutusyoname1.validate();
			this.$refs.nmMoutusyoname2.validate();
			this.$refs.nmMoutusyokana1.validate();
			this.$refs.nmMoutusyokana2.validate();
			this.$refs.dtMoubirthday.validate();
			this.$refs.noMouzip1.validate();
			this.$refs.noMouzip2.validate();
			this.$refs.txMouadr1.validate();
			this.$refs.txMouadr2.validate();
			this.$refs.txMouadr3.validate();
			this.$refs.idMoutel1.validate();
			this.$refs.idMoutel2.validate();
			this.$refs.idMoutel3.validate();
			this.$refs.nuKyojyu.validate();
			this.$refs.kbZairyusikaku.validate();
			this.$refs.dtZairyuStt.validate();
			this.$refs.dtZairyuEnd.validate();
			this.$refs.moSyotoku.validate();
			this.$refs.fgKojto.validate();

			// アコーディオン（申込日時点の勤務先又は学校の名称・所在地）を開く
			this.disp.isFilterOpen = true;
			await this.$nextTick();
			this.$refs.dtYmdStt.setValue(this.formC1.dtYmdStt, false);

			this.$refs.txSyozaichi.validate();
			this.$refs.txName.validate();
			this.$refs.idTel1.validate();
			this.$refs.idTel2.validate();
			this.$refs.idTel3.validate();
			this.$refs.dtYmdStt.validate();
			this.$refs.cdSyokugyo.validate();

			this.$refs.kbKaidan.validate();
			this.$refs.kbSyoyu.validate();
			this.$refs.kbBekkyoyotei.validate();
			this.$refs.txKiboJyoken.validate();
			this.$refs.fgTokubetu.validate();
			this.$refs.kbShinGaitokomoku.validate();
			// アコーディオン（住宅の詳細）を開く
			this.disp.isDetailOpen = true;
			await this.$nextTick();

			if (this.disp.isBekkyoFlg) this.$refs.txBekkyozyokyo.validate();
			this.$refs.cdNowjyutaku.validate();
			this.$refs.moNowyachin.validate();
			this.$refs.cdNowmadori.validate();
			this.$refs.nuNowtatamisu.validate();
			this.$refs.nuNowsenyo.validate();
			this.$refs.fgSeiyakuDoui.validate();
			this.$refs.kbAnketo1ans.validate();
			this.$refs.txAnketo1ansetc.validate();
			this.$refs.kbAnketo2ans.validate();
			this.$refs.txAnketo2ansetc.validate();
			this.$refs.kbAnketo3.validate();
			this.$refs.txAnketo3ansetc.validate();
			this.$refs.txAnketo4ans.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			return true;
		},
		// 複数項目チェック
		checkInputMultiple : async function () {

			let inputError = false;
			this.disp.nyukyoNinzuErrFlg = false;

			// 同居人数チェック
			if (this.formC1.nuDoukyo <= 0) {
				// 同居人数エラー
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'nuDoukyo', msg: co_getMessage('E0056', '同居人数', '1人以上')});
				this.$refs.nuDoukyo.setError();
				if (!inputError) this.$refs.nuDoukyo.focus();
				inputError = true;
			}

			// 入居予定人数チェック１
			if (this.formC1.kbBosyu.substring(2) == '1'
				&& this.formC1.kbZyutaku != '18'
				&& this.formC1.nuNyukyo < 2) {
				// 入居予定人数エラー１
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'nuNyukyo', msg: co_getMessage('E0059')});
				this.$refs.nuNyukyo.setError();
				if (!inputError) this.$refs.nuNyukyo.focus();
				inputError = true;
			}

			// 入居人数相違チェック
			if (Number(this.formC1.nuNyukyo-1) != Number(this.formC1.nyukyoList.filter(item => item.isInputCheck).length)) {
				// 入居人数相違エラー
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'nuNyukyo', msg: co_getMessage('E0016')});
				this.$refs.nuNyukyo.setError();
				if (!inputError) this.$refs.nuNyukyo.focus();
				inputError = true;
				this.disp.nyukyoNinzuErrFlg = true;
			}

			// 都以外郵便番号チェック
			let zipCodeInfo = {
				'zipcode' : this.formC1.noMouzip1 + this.formC1.noMouzip2
			};
			// 住所検索
			let txMouadr = await co_post(API_ADDRESS_INFO, zipCodeInfo);
			if (txMouadr.indexOf('東京都') == -1) {
				// 都以外郵便番号エラー
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'noMouzip', msg: co_getMessage('E0028')});
				this.$refs.noMouzip1.setError();
				this.$refs.noMouzip2.setError();
				if (!inputError) this.$refs.noMouzip1.focus();
				inputError = true;
			}

			// 住所妥当性チェック
			if (this.formC1.txMouadr1.indexOf('市') == -1
				&& this.formC1.txMouadr1.indexOf('区') == -1
				&& this.formC1.txMouadr1.indexOf('町') == -1
				&& this.formC1.txMouadr1.indexOf('村') == -1) {

				// 住所妥当性エラー
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'txMouadr', msg: co_getMessage('E0008')});
				this.$refs.txMouadr1.setError();
				if (!inputError) this.$refs.txMouadr1.focus();
				inputError = true;

			}

			// 都内居住年数チェック
			if (this.formC1.nuKyojyu <= 0) {

				// 都内居住年数エラー
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'nuKyojyu', msg: co_getMessage('E0056', '都内居住年数', '1年以上')});
				this.$refs.nuKyojyu.setError();
				if (!inputError) this.$refs.nuKyojyu.focus();
				inputError = true;
			}

			// 在留期間大小チェック
			if (this.formC1.dtZairyuStt > this.formC1.dtZairyuEnd) {
				// 在留期間大小チェックエラー
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'zairyuKikan', msg: co_getMessage('E0017')});
				this.$refs.dtZairyuStt.setError();
				this.$refs.dtZairyuEnd.setError();
				if (!inputError) this.$refs.dtZairyuStt.focus();
				inputError = true;
			}

			// 年間所得金額チェック
			if (this.formC1.moSyotoku < 0) {

				this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'moSyotoku', msg: co_getMessage('E0056', '年間所得金額', '0円以上')});
				this.$refs.moSyotoku.setError();
				if (!inputError) this.$refs.moSyotoku.focus();
				inputError = true;
			}

			// 電話番号チェック
			if (!co_isEmpty(this.formC1.idTel1) || !co_isEmpty(this.formC1.idTel2) || !co_isEmpty(this.formC1.idTel3)) {
				if (co_isEmpty(this.formC1.idTel1)) {
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'tel', msg: co_getMessage('E0011', '電話番号（市外）')});
					this.$refs.idTel1.setError();
					if (!inputError) this.$refs.idTel1.focus();
					inputError = true;
				}
				if (co_isEmpty(this.formC1.idTel2)) {
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'tel', msg: co_getMessage('E0011', '電話番号（市内）')});
					this.$refs.idTel2.setError();
					if (!inputError) this.$refs.idTel2.focus();
					inputError = true;
				}
				if (co_isEmpty(this.formC1.idTel3)) {
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'tel', msg: co_getMessage('E0011', '電話番号（局番）')});
					this.$refs.idTel3.setError();
					if (!inputError) this.$refs.idTel3.focus();
					inputError = true;
				}
			}

			// 特別控除エラーチェック
			if (!co_isEmpty(this.formC1.fgKojto)) {
				let kojyoList = this.formC1.fgKojto.split(',');

				// 障害者、特別障害者が両方選択されている場合
				if (kojyoList.findIndex(item => item === '3') >= 0
					&& kojyoList.findIndex(item => item === '4') >= 0) {
					
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'fgKojto', msg: co_getMessage('E0019')});
					this.$refs.fgKojto.setError();
					if (!inputError) this.$refs.fgKojto.focus();
					inputError = true;
				}
				// 寡婦、ひとり親が両方選択されている場合
				if (kojyoList.findIndex(item => item === '5') >= 0
					&& kojyoList.findIndex(item => item === '6') >= 0) {
					
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'fgKojto', msg: co_getMessage('E0117')});
					this.$refs.fgKojto.setError();
					if (!inputError) this.$refs.fgKojto.focus();
					inputError = true;
				}
			}

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			// 特別控除・所得金額超過チェック処理（サーバー側）
			this.formC1.nuKazoku = Number(this.formC1.nuNyukyo) + Number(this.formC1.fuyoList.filter(item => item.isInputCheck == true).length);
			let errinfo = await co_post(PATH_BC058_CHECK, this.formC1);
			if (errinfo == null) {

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// システムエラー画面へ遷移
				co_moveSystemError([E3005]);
				return;
			}

			if (!co_isEmpty(errinfo.messageID)) {

				// 特別控除エラーの場合
				if (errinfo.messageID == 'E0107') {	
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'fgKojto', msg: co_getMessage('E0107')});
					this.$refs.fgKojto.setError();
					if (!inputError) this.$refs.fgKojto.focus();

				// 所得金額超過エラーの場合
				} else if (errinfo.messageID == 'E0140' && !inputError) {
					co_errorLinkDialog(co_getMessage('E0140', this.disp.linkInfo1, this.disp.linkInfo2, this.disp.linkInfo3, errinfo.param1), this.callBack);
					return false;
				} 
				inputError = true;
			}

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			return true;

		},
		// コールバック関数
		callBack: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// ページトップへ遷移
				co_toTop();
				return;
			}
		},
		// 申込者年間所得金額ロストフォーカス
		changeMoSyotoku: async function () {

			// 世帯の所得金額計算
			this.$emit('clacAmount');
		},
		// 申込者勤務先等アコーデオン開閉処理
		filterOpen: async function () {

			this.disp.isFilterOpen = !this.disp.isFilterOpen;
			if (this.disp.isFilterOpen) {
				await this.$nextTick();
				// 勤務（開業）開始日設定
				this.$refs.dtYmdStt.setValue(this.formC1.dtYmdStt, false);
			}
		},
	}
}

</script>

<style scoped>
.table-border-top {
	border-top: none !important;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.font-size {
		font-size: 16px !important;
	}

	.contents__main {
		margin-left: 0% !important;
		margin-right: 0% !important;
	}

	.contents__input-main {
		margin-top: -2%;
	}

	.width-attention {
		font-size: 20px;
		margin-left: 5px;
	}

	.contents__jyutaku {
		margin-top: 1%;
		display: inline-block;
	}

	.width-jyutakuhenko {
		margin-left: 65%;
		margin-top: 5px;
		margin-bottom: 3px;
	}

	.contents__mosikomi1,
	.contents__mosikomi2,
	.contents__mosikomi3 {
		margin-top: 1% !important;
		display: inline-block;
	}

	.mouName-title {
		padding-top: 12px !important;
	}

	.width-bosyu,
	.width-jyutaku {
		padding-top: 25px !important;
	}

	.width-dokyo {
		width: 55px;
		margin-right: 5px;
	}

	.contents__table--stripe td {
		line-height: 0px;
	}

	.contents__nyukyotyui1 {
		padding-top: 15px !important;
	}

	.contents__nyukyotyui2 {
		font-size: 16px;
	}

	.width-moukbn1 {
		margin-top: 10px;
		margin-bottom: 10px;
		line-height: 0px;
	}

	.width-zip1 {
		width: 75px;
	}

	.width-zip2 {
		width: 84px;
	}

	.width-jyusyo {
		width: 498px;
		margin-bottom: 5px;
	}

	.jyusyo-tyui2 {
		font-size: 16px !important;
	}

	.width-tel1,
	.width-tel2,
	.width-tel3 {
		width: 84px;
	}

	.tel-tyui {
		font-size: 16px !important;
	}
	
	.width-kyojyuNensu {
		width: 66px;
	}

	.kyojyuNensu-tyui {
		font-size: 16px !important;
	}

	.zairyu-title {
		border-bottom: none;
	}

	.zairyu-tyui {
		font-size: 16px !important;
		margin-top: -5px;
		margin-bottom: 15px;
	}

	.zairyuSikaku-title {
		border-bottom: none;
		line-height: 0px;
	}

	.width-zairyuKikanFrom {
		float: left;
		margin-right: 2px;
	}

	.width-zairyuKikanTo {
		font-size: 16px;
	}

	.nyukyo-title {
		background-color: #fe0000;
		position: relative;
		bottom: 2px; color: #ffffff;
		font-size: 12px;
		margin: 5px 0;
		padding: 2px 2px;
		border-radius: 3px;
		line-height: 1.3em;
	}

	.contents__list {
		line-height: 25px;
	}

	.table-button {
		margin-bottom: 4%;
		margin-top: 4%;
	}

	.contents__syotoku-kazoku {
		padding-top: 25px !important;
	}

	.contents__syotoku-tyui,
	.contents__totisyoyu-tyui {
		padding-top: 15px !important;
	}

	.kazoku-ninzu {
		padding-top: 25px !important;
	}

	.syotoku-tyui,
	.kazokuNizu-tyui {
		position: relative;
		top: -5px;
	}

	.width-jyutakuKind-title {
		width: 6.5% !important;
	}

	.contents__acordion {
		background-color: #cdcdcd;
		padding-top: 5px;
		padding-bottom: 5px;
		border-bottom: 1px dashed #aaaaaa;
	}

	.width-acordion {
		padding-left: 1%;
	}

	.square-position {
		padding-right: 20px;
		float: right;
	}

	.contents__yatin {
		background-color: #f1f2f5;
		border-top: 1px solid #f1f2f5;
	}

	.width-yatin-title {
		width: 6.5% !important;
	}

	.width-yatin {
		width: 120px;
	}

	.contents__madori {
		background-color: #fdfdfd !important;
	}

	.width-madori-title {
		width: 22%;
	}

	.width-madori {
		width: 28%;
	}

	.width-tatamisu-title {
		width: 30%;
	}

	.width-tatamisu {
		width: 20%;
	}

	.contents__senyoArea {
		background-color: #f1f2f5 !important;
	}

	.senyoArea-tyui {
		line-height: 0px;
	}

	.contents__totiSyoyu--div {
		height: 54px;
	}
	_::-webkit-full-page-media, _:future, :root .contents__totiSyoyu--div {
		height: 58px;
	}

	.doui-tyui {
		line-height: 21px;
		margin-bottom: 10px;
	}

	.width-seiyakuDoui {
		margin-top: 25px;   
		margin-bottom: 15px;
		margin-left: -10px;
	}

	.margin-bekkyoZyokyo {
		margin-bottom: 50px;
		margin-left: 16px;
	}

	.width-bekkyoZyokyo {
		height: 96px;
		margin-bottom: -40px;
	}

	.contents__enquete {
		line-height: 1.4em !important;
	}

	.width-biko,
	.width-enquete1,
	.width-enquete4 {
		height: 96px;
		margin-bottom: 8px;
	}

	.width-enquete2,
	.width-enquete3 {
		margin-bottom: 8px;
		margin-left: 0px;
	}

	.contents__btn-statement {
		text-align: left;
		padding-left: 15%;
		margin-top: 15px;
		margin-bottom: 15px;
	}

	.btn-statement1,
	.btn-statement2,
	.btn-statement3 {
		display: inline-block;
		text-align: left;
		width: 81%;
	}

	.btn-itiji-hozon {
		margin-bottom: 2%;
		margin-right: 1%;
	}

	.btn-kakunin {
		margin-bottom: 2%;
	}

	.btn-modoru {
		margin-left: 1%;
	}

	.list {
		margin: 0 auto 30px;
		text-align: center;
	}
	.list tr:nth-child(1){
		background-color: #e7f5ff;
		color: #00008b;
	}
	.detail_split th:nth-child(3) {
		width: 14% !important;
	}
	.detail_split td:nth-child(4) {
		width: 36%;
	}

	.list th:nth-child(1){ width:7%; }
	.list th:nth-child(2){ width:12%; }
	.list th:nth-child(3){ width:24%; }
	.list th:nth-child(4){ width:4%; }
	.list th:nth-child(5){ width:10%; }
	.list th:nth-child(6){ width:10%; }
	.list th:nth-child(7){ width:8%; }
	.list th:nth-child(8){ width:11%; }
	.list th:nth-child(9){ width:4%; }

	/* 同居者一覧 */
	.list2 {
		margin: 0 0 30px;
		text-align: center;
	}

	.list2 th:nth-child(1){ width:11%; }
	.list2 th:nth-child(2){ width:11%; }
	.list2 th:nth-child(3){ width:3%; }
	.list2 th:nth-child(4){ width:17%; }
	.list2 th:nth-child(5){ width:9%; }
	.list2 th:nth-child(6){ width:7%; }
	.list2 th:nth-child(7){ width:12%; }
	.list2 th:nth-child(8){ width:16%; }
	.list2 th:nth-child(9){ width:14%; }

	/* 遠隔地扶養者一覧 */
	.list3 {
		margin: 0 0 30px;
		text-align: center;
	}

	.list3 th:nth-child(1){ width:17%; }
	.list3 th:nth-child(2){ width:11%; }
	.list3 th:nth-child(3){ width:3%; }
	.list3 th:nth-child(4){ width:22%; }
	.list3 th:nth-child(5){ width:20%; }
	.list3 th:nth-child(6){ width:9%; }
	.list3 th:nth-child(7){ width:18%; }

	.narrow_row {
		line-height: 1.2em;
	}
	.detail .no_border_bottom .detail_split {
		border-bottom: none;
	}
		
	.contents__thtd--btn {
		background-color: #fdfdfd;
		border-color: #fdfdfd;
	}

	.contents__caution--multiple {
		line-height: 1.4em !important;
	}
	.contents__div--error {
		border: 1px solid #b30000;
		border-radius: 5px;
		padding: 10px 0 10px 10px;
		background-color: #fde9f3;
	}
	.contents__hissu {
		right: 1%;
	}

	#listheader {
		background-color: #e7f5ff;
		color: #00008b;
	}

	/* 入居人数(ヘッダ) */
	#listtitle01 {
		width: 7%;
	}

	/* 申込地区番号(ヘッダ) */
	#listtitle02 {
		width: 10%;
		padding: 5px 0px;
		line-height: 22px;
	}
	#listtitle12 {
		width: 12%;
		padding: 5px 0px;
		line-height: 22px;
	}

	/* 住宅名(ヘッダ) */
	#listtitle03 {
		width: 23%;
		line-height: 22px;
	}
	#listtitle13 {
		width: 24%;
		line-height: 22px;
	}
	#listtitle23 {
		width: 28%;
		line-height: 22px;
	}

	/* 募集戸数(ヘッダ) */
	#listtitle04 {
		width: 4%;
		line-height: 22px;
	}

	/* 間取り(ヘッダ) */
	#listtitle05 {
		width: 10%;
		line-height: 22px;
	}

	/* 建設年度(ヘッダ) */
	#listtitle06 {
		width: 10%;
		line-height: 22px;
	}

	/* 使用料(ヘッダ) */
	#listtitle07 {
		width: 8%;
	}

	/* 仕様等(ヘッダ) */
	#listtitle08 {
		width: 12%;
	}
	#listtitle18 {
		width: 11%;
	}

	/* 参考倍率・事故内容(ヘッダ) */
	#listtitle09 {
		width: 10%;
	}
	#listtitle19 {
		width: 4%;
		line-height: 22px;
	}
	#listtd {
		text-align: center;
		line-height: 21px;
	}
	#listjyusho {
		text-align: left;
		line-height: 21px;
	}
	#listtdleft {
		line-height: 21px;
	}
	.list-Countents {
		background-color: white !important;
		color: #000000 !important;
	}

	/* アンケート（チェックボックス） */
	.contents__div--anketo {
		line-height: 1.7em;
	}

	/* 申込区分 */
	.width-mosikomi,
	.width-zairyu {
		width: auto;
	}

	/* 住宅の種別 */
	.padding-jyutaku {
		padding-top: 19px !important;
	}

	.contents__table--nyukyo {
		border: 1px solid #808080;
	}

	.nyukyo-error {
		width: auto;
		margin-bottom: 6px  !important;
	}
	.br-962px {
		display: none;
	}

	.margin__tusyoTyui {
		margin-left: 5px;
		font-size: 15px;
	}

	.margin-bekkyoUmu {
		margin-top: 55px;
	}

	.bekkyo-title {
		padding-top: 12px !important;
	}

	.bekkyoText-tyui {
		margin-top: 20px;
		margin-left: 15px;
		margin-bottom: 10px;
	}

	.contents__kiboJyoken {
		line-height: 18px;
		margin-top: 15px;
	}

	.padding__syotoku,
	.padding__kojyo {
		padding-bottom: 10px !important;
	}

	.width-kojyo-item {
		margin-top: 15px;
		margin-bottom: 25px;
	}

	.contents__filter--title {
		background-color: #cdcdcd;
		padding-top: 0px;
		padding-bottom: 0px;
	}

	.accordion-title {
		margin-top: -20px;
	}

	.contents__div--tokubetu {
		line-height: 1.7em;
	}
}

.contents__tusyoTyui {
	margin-top: 5px;
	margin-bottom: 15px;
	color: red;
}

.bekkyo-title-hissu {
	position: relative !important;
	font-weight: bold;
}

.width-textarea {
	width: -webkit-fill-available;
}

.margin__anketo-etc {
	margin-top: 3px;
}

.margin__nyukyoList-tyui {
	margin-bottom: 10px;
	margin-left: 16px;
}

.width-bekkyoUmu {
	margin-top:10px;
	margin-left:15px;
}

.contents__bekkyoList {
	margin-bottom: 15px !important;
}

.jusyo-marginTop {
	margin-top: 5px !important;
}

.contents__filter--title {
	text-align: left;
}

.width-auto {
    width: auto !important;
}

.contents__tokubetu {
	display: inline-grid;
}

/* アコーディオン表示・非表示 */
@keyframes open {
	0% {
		opacity: 0;
		transform: translateY(-5px);
	}
	100% {
		opacity: 1;
		transform: translateY(0px);
	}
}

_::-webkit-full-page-media, _:future, :root .margin__anketo-etc {
	margin-top: 8px;
}

</style>